import { LitElement, html, css, TemplateResult, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { voyageCursorStyles } from '../../voyage-style/src/voyage-style';
import { FailedUIRouteWithMetadata, RouteGeometry, RoutingJobOptions, VoyageRoute, VoyageRouteLineFeature, VoyageRoutePointFeature, VoyageRoutingModel, MissingPoints, WeatherRoutingInfo, WniRequiredReason } from '../../../src/models/voyage-routing-model';
import { VoyageDialogPopupManager } from '../../voyage-dialog-popup/src/voyage-dialog-popup-manager';
import '../../voyage-spinner/src/voyage-spinner';
import '../../voyage-route-export/src/voyage-route-export';
import './voyage-route-comparison';
import'./voy-error-popup';
import { PlanChangedEvent, RouteAdoptionResult, VesselPlanningModel, VoyagePlan } from '../../../src/models/vessel-planning-model';
import { WeatherModel } from '../../../src/models/weather-model';
import { RouteEditModel } from '../../../src/models/route-edit-model';
import { UUID, deepEqual, isOnline } from  '../../../src/utils/helpers';
import { VesselPositionModel } from '../../../src/models/vessel-position-model';
import {  getMostFuelEfficientStarRoute, getNextWaypointIndex, getPilotPointIndeces, insertCurrentPositionWP, isPointWithinStoppageWindow, markPassedAndAddCurrentPosition, markPassedWaypoints, handleWeatherRouting, validateExtension, downloadJobLog, extractShallowSoundings } from '../../../src/utils/route-utils';
import { GetFormattedDate, isStarRouteDeviationEnabled } from '../../../src/utils/helpers';
import { getCrossingZoneCount, routeNeedsWarningsReview, routeWarningsReviewed } from '../../../src/utils/zone-crossing-utils';
import { TerminalsModel } from '../../../src/models/terminals-model';
import { SposConverter } from '../../../src/converters/spos-converter';
import { RTZConverter } from '../../../src/converters/rtz-converter';
import { DropDown_Options, ElementMapper,CalculatedValues, UIRouteWithCalculatedValues, SuggestedRouteEvents, StarRoute1, SuggestedRouteStatusEvents } from './types';
import { VoyageBestPracticeRoutesModel } from '../../../src/models/voyage-best-practice-routes-model';
import {  BestPracticeRoutesEvents } from '../../../src/models/voyage-best-practice-routes-model-impl';
import { getBorderColor ,getBackgroundColor, calculateRouteValues ,getDefaultCalculatedValues, getSegregatedRouteIndices, starRouteFetchDisabled, checkIfOwnRouteIsMoreFuelEfficientThanStarRouteOne, WRStatus, showDeleteIcon, voyageSuggestedStyles, checkifValidRoute, formatCountdown } from './helper';
import { VesselPlansService } from '../../../src/services/vessel-plans-service';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { ZonesUtilities } from '../../../src/utils/zones/zones-utilities-base';
import { WhaleZonesUtilities } from '../../../src/utils/zones/whale-zones-utils';
import { VoyageWeatherRoutingModel } from '../../../src/models/weather-routing-model';
import { VesselClfPopupModel } from '../../../src/models/vessel-clf-popup-model';
import { DataExtractor } from '../../voyage-passage-plan/src/data-extractor';
import { AlignBPREvent } from '../../voyage-passage-plan/src/voyage-passage-plan-overview/type';
import '@maersk-global/mds-components-core/mc-switch'
import '@maersk-global/mds-components-core/mc-loading-indicator';
import '@maersk-global/mds-components-core/mc-step-indicator';
import '@maersk-global/mds-components-core/mc-step-indicator-item';
import "./align-star-route-modal";
import { VoyageImoModel } from '../../../src/models/voyage-imo-model';
import { CLF_POPUP_CANCEL_CLICKED, CLF_POPUP_SUBMIT_CLICKED } from '../../vessel-clf-popup/src/vessel-wr-clf-popup';
import { AlertType, VesselAlertsModel } from '../../../src/models/vessel-alerts-model';
import { captureStarRouteWrWorkflowEvent, faro } from '../../../src/utils/rum-utility';
import { compareReimportedRouteWithStarRoute, findExportedStarRouteForImport, getRouteOrigin, RouteUploadSource } from '../../../src/utils/utils';
import { importFromFile } from '../../../src/converters/converters';
import { ISHIGHLIGHTSHALLOWSOUNDINGSENABLED } from '../../../src/models/feature-flag-model-impl';
import { CONST_POW_ENDPOINT_V2, FeatureFlagModel } from '../../../src/models/feature-flag-model';
import { BprJobErrorDetails, BprJobResult, RouteChecksSummary, StageEstimate } from '../../../src/services/route-optimiser-service';
import { VoyageToastManager } from '../../voy-toast/src/voy-toast-manager';

type BprProgressStep = {
    key: string;
    title: string;
    detail?: string;
};

enum RouteChange
{
    None = 0,
    NotCalculated,
    Coordinates,
    Draft,
    GMt,
    ETA,
    ETD,
    NewForecast,
    ForecastUpdated,
    WeatherLimits
}


enum Status {
    user_route_was_created = 'user_route_was_created',
    auto_route_was_created = "auto_route_was_created",
    get_auto_route = "get_auto_route",
    no_route = "no_route"
}

const RouteChangeToTextMap: Map<RouteChange,string> = new Map([
    [RouteChange.Coordinates, "Route start and/or end position has changed."],
    [RouteChange.Draft, "Draft has been changed."],
    [RouteChange.GMt, "GMt has been changed."],
    [RouteChange.ETA, "ETA has been changed."],
    [RouteChange.ETD, "ETD has been changed."],
    [RouteChange.NewForecast, "New weather forecast is available."],
    [RouteChange.ForecastUpdated, "Additional high resolution data for weather forecast is available."],
    [RouteChange.WeatherLimits, "Weather limits have been changed."]
]);

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

@customElement('voyage-suggested-routes')
export class VoyageSuggestedRoutes extends LitElement
{
    @property({ attribute: false }) private _isBestPracticeRouteAvailable: boolean = false;
    @property({ attribute: false }) private showBprLoader: boolean = false;
    @property({ attribute: false }) private _isOOREnabled: boolean = false;
    @property({ attribute: false }) private _hideBprRoute: boolean = false;
    @property({ attribute: false }) private _bprRouteStatusMsg: string = '';
    @property({ attribute: false }) private _remainingSeconds: number | null = null;
    @property({ attribute: false }) private _isProgressExpanded: boolean = false;
    @property({ attribute: false }) private _bprProgressSteps: BprProgressStep[] = [];
    @property({ attribute: false }) private _bprJobError: string | null = null;
    @property({attribute: false}) private _loading: boolean = isOnline();
    @property({ attribute: false }) private _showBprResultSummary: boolean = false;
    @property({ attribute: false }) private _bprCalculationError: string | null = null;
    @property({ attribute: false }) private _bprRouteChecks: RouteChecksSummary | null = null;

    private _stageEstimate: StageEstimate | null = null;
    private _countdownInterval?: ReturnType<typeof setInterval>;
    private _bprGenerationActive = false;
    private isAccordianOpen;
    private eventSource: EventSource|null = null;
    constructor() {
        super();
        this._allignSelectedIndexToCurrentSelected = this._allignSelectedIndexToCurrentSelected.bind(this);
        this._onRoutesChanged = this._onRoutesChanged.bind(this);
        this._onWeatherLimitsChanged = this._onWeatherLimitsChanged.bind(this);
        this._onPlanChanged = this._onPlanChanged.bind(this);
        this._bestPracticeRouteChanged = this._bestPracticeRouteChanged.bind(this);
        this._onPassagePlanClicked = this._onPassagePlanClicked.bind(this);
        this._renderRetryBprModal = this._renderRetryBprModal.bind(this);
        this._renderOorFailedModal = this._renderOorFailedModal.bind(this);
        this._onStageEstimateChanged = this._onStageEstimateChanged.bind(this);
        this._onJobProgressChanged = this._onJobProgressChanged.bind(this);
        this._selectRoute = this._selectRoute.bind(this);
        this.isAccordianOpen = true;
        this._loading = false;
        this._showLoader = this._showLoader.bind(this);
        this._hideLoader = this._hideLoader.bind(this);
        this._handleNetworkChange = this._handleNetworkChange.bind(this);
        this._editRoute = this._editRoute.bind(this);
        this._onAcceptAdviceClicked = this._onAcceptAdviceClicked.bind(this); 
        this._onDismissAdviceClicked = this._onDismissAdviceClicked.bind(this);
        this._onWRCLfPopupSubmitted = this._onWRCLfPopupSubmitted.bind(this);
    }

    set scheduleId(value)
    {
        this._scheduleId = value;
        this._updateFromPlan(true);
    }

    @property({type: String, attribute: "schedule-id"})
    get scheduleId()
    {
        return this._scheduleId;
    }

    static get styles() {
        return [
            voyageCursorStyles,
            css`
            :host {
                margin: 10px;
                display: block;
                line-height: normal;
            }

            .contanier-route {
                display: grid;
                position: relative;
                grid-template-columns: 100%;
                font-family: MaerskText;
                align-items: center;
            }
             .route-card-item {
                cursor: pointer;
                border: 2px solid var(--neutrals-grey-06, grey);
                font-family: MaerskText;
                align-items: center;
                border-radius: 4px;
                padding: 0px 16px;
                margin-bottom: 8px;
            }
            .loader {
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                margin-bottom: 30px;
            }    
            .loadingOverlay {
                position: absolute;
                top: -1px;
                bottom: -1px;
                right: -1px;
                left: -1px;
                z-index: 10;
                background-color: rgba(var(--neutrals-grey-01-rgb), 0.5);
                border-radius: 3px;
            }
            .disable {
                opacity: 0.5;
                cursor: not-allowed;
            }
            .view-more {
                color: var(--primary-blue-03, #0073ad);
                cursor: pointer;
                margin-left: 4px;
            }
            .view-more:hover {
                text-decoration: underline;
            }

            /* "Needs Review" pill on the Route Warnings row */
            .needs-review {
                position: absolute;
                left:105px;
                display: inline-flex;
                align-items: center;
                column-gap: 4px;

                margin-left: 6px;
                padding: 1px 4px;
                border-radius: 12px;

                background-color: var(--feedback-danger-background, #fce8e6);
                color: var(--feedback-danger-text, #b5241c);
                font-size: 12px;
                line-height: 18px;
                white-space: nowrap;
            }

            .needs-review > svg {
                width: 12px;
                height: 12px;
                flex: 0 0 auto;
            }

            /* Same pill, green, once the warnings have been reviewed. */
            .needs-review[reviewed] {
                background-color: var(--feedback-success-background, #e8f5e9);
                color: var(--feedback-success-text, #1a7a2e);
            }

            /* Hover target for the tooltip on an action the review blocks. A disabled button does
               not emit pointer events itself, so the wrapper carries them. */
            .review-gate {
                display: block;
            }

            /* Passage Plan is a full-width button, so its gate has to span the row too. */
            .review-gate-tooltip[full],
            .review-gate-tooltip[full] .review-gate {
                width: 100%;
            }
            .route-tooltip-text {
                width:300px;
            }

            voyage-spinner {
                width: 50px;
                height: 50px;
                left: calc(50% - 25px);
                top: calc(50% - 25px);
                position: absolute;
            }
            .offline-routes-container {
                display: flex;
                flex-direction: row;
                align-items: start;
                justify-content: center;
                margin: 20px 0 10px;
                background-color: #d4d2d2;
                padding: 6px 15px;
                border-radius: 20px;  
            }
            .offline-routes-container .exclamation-icon {
                position: relative;
                right: 5px;
                height: 20px;
                width: 20px;
                left: inherit;
            }
            .bpr-result-summary p {
                margin: 4px 0;
            }
            .bpr-result-summary {
                box-sizing: border-box;
                height: auto;
                max-height: 270px;
                min-height: 120px;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 16px;
            }
            .bpr-error {
                color: var(--maersk-red, #cc0000);
                font-weight: bold;
                overflow-wrap: anywhere;
                white-space: pre-line;
            }           `,
            voyageSuggestedStyles,
        ]
    };

    private isDisabled = false;

    private _handleNetworkChange(evt: Event) {
        // Update state based on event detail
        const e = evt as CustomEvent;
        this.isDisabled = !e.detail.online;
        this.requestUpdate();
    }

    connectedCallback()
    {
        super.connectedCallback();
        VoyageRoutingModel!.addEventListener(SuggestedRouteEvents.RoutesChanged, this._onRoutesChanged);
        VoyageRoutingModel!.addEventListener(SuggestedRouteEvents.StarRoutesChanged, this._onRoutesChanged);
        // The flags arrive asynchronously, so the Needs Review tag and the gated actions have to
        // re-render once const_pow_endpoint_v2 shows up in a feature flags response.
        FeatureFlagModel?.addEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
        VoyageRoutingModel!.addEventListener(SuggestedRouteEvents.WeatherLimitsChanged, this._onWeatherLimitsChanged);
        VesselPlanningModel!.addEventListener(SuggestedRouteEvents.PlanChanged, <EventListener>this._onPlanChanged);
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteEvents.BestPracticeRouteChanged,  this._bestPracticeRouteChanged);
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteEvents.RetryBprJob, this._renderRetryBprModal);
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteEvents.OorCalculationFailed, this._renderOorFailedModal);
        VesselClfPopupModel!.addEventListener(CLF_POPUP_SUBMIT_CLICKED, (event: Event) => {
            this._onWRCLfPopupSubmitted(event);
        });
        VesselClfPopupModel!.addEventListener(CLF_POPUP_CANCEL_CLICKED, this._onWRCLfPopupClosed);
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteEvents.RankedBPRUpdated, (event: Event) => {
            const customEvent = event as CustomEvent;
            this._checkIfBPRisAvailable(this._scheduleId, customEvent.detail.bprOptimizedLength, customEvent.detail.ukcFailedRoutesLength, true);
            this._showBprJobCompletionSummary(customEvent.detail.errorDetails);
            if (this._bprGenerationActive && customEvent.detail.bprOptimizedLength > 0) {
                VoyageToastManager.createToast({ message: 'Route Generated Successfully.', type: 'success' });
            }
            this._bprGenerationActive = false;
        });
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteEvents.RankedBPRStarted, () => {
            this._bprGenerationActive = true;
            this._hideBprRoute = true;
            this.showBprLoader = true;
            this._clearCountdown();
            this._bprProgressSteps = [];
            this._bprJobError = null;
            this._isProgressExpanded = false;
            // Routes are being recalculated - any warning based on the previous results is stale
            // until the recalculation finishes (_checkIfBPRisAvailable re-evaluates it then).
            const imo = isVesselOnCloud ? VoyageImoModel!.imo! : (<any>window)["appenv"].vesselIMONumber;
            VesselAlertsModel!.removeAlertsByType(imo, AlertType.StarRouteNegativeUkcWarning);
            this.requestUpdate();
        });
        VesselPlanningModel?.addEventListener(AlignBPREvent.SelectStarRouteOne, (e:any) =>this._selectRouteId( e.detail?.index, e.detail?.routeId));
        VesselPlanningModel?.addEventListener(AlignBPREvent.ShowStarRouteModal, () => {
            this._showAlignStarRouteModal = true; 
            this.requestUpdate();
        });
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteStatusEvents.StatusChanged, (event: Event) => {
            const customEvent = event as CustomEvent;
            if (this._hideBprRoute) {
                this._bprRouteStatusMsg = customEvent.detail;
            }
            this.requestUpdate();
        });
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteStatusEvents.StageEstimateChanged, this._onStageEstimateChanged);
        VoyageBestPracticeRoutesModel!.addEventListener(SuggestedRouteStatusEvents.JobProgressChanged, this._onJobProgressChanged);
        VoyageImoModel!.addEventListener('updating-plan-event', this._showLoader)
        VoyageImoModel!.addEventListener('updating-plan-event-completed', this._hideLoader)
        VoyageImoModel!.addEventListener('updating-plan-event-failed', this._hideLoader)
        window.addEventListener('network-change', this._handleNetworkChange);

        this._onRoutesChanged();
    }

    disconnectedCallback()
    {
        super.disconnectedCallback();
        VoyageRoutingModel!.removeEventListener(SuggestedRouteEvents.RoutesChanged, this._onRoutesChanged);
        VoyageRoutingModel!.removeEventListener(SuggestedRouteEvents.WeatherLimitsChanged, this._onWeatherLimitsChanged);
        FeatureFlagModel?.removeEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
        VesselPlanningModel!.removeEventListener(SuggestedRouteEvents.PlanChanged, <EventListener>this._onPlanChanged);
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteEvents.BestPracticeRouteChanged,  this._bestPracticeRouteChanged)
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteEvents.RetryBprJob, this._renderRetryBprModal);
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteEvents.OorCalculationFailed, this._renderOorFailedModal);
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteEvents.RankedBPRUpdated,() => this._checkIfBPRisAvailable(this._scheduleId));
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteEvents.RankedBPRStarted, (event: Event) => {
            this._hideBprRoute = false;
            this.requestUpdate();
        });
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteStatusEvents.StatusChanged, (event: Event) => {
            const customEvent = event as CustomEvent;
            if (this._hideBprRoute) {
                this._bprRouteStatusMsg = customEvent.detail;
            }
            this.requestUpdate();
        });
        VesselPlanningModel?.removeEventListener(AlignBPREvent.SelectStarRouteOne, (e:any) =>this._selectRouteId( e.detail?.index, e.detail?.routeId));
        VoyageImoModel!.removeEventListener('updating-plan-event', this._showLoader)
        VoyageImoModel!.removeEventListener('updating-plan-event-completed', this._hideLoader)
        VoyageImoModel!.removeEventListener('updating-plan-event-failed', this._hideLoader)
        VesselClfPopupModel!.removeEventListener(CLF_POPUP_SUBMIT_CLICKED, this._onWRCLfPopupSubmitted);
        VesselClfPopupModel!.removeEventListener(CLF_POPUP_CANCEL_CLICKED, this._onWRCLfPopupClosed);
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteStatusEvents.StageEstimateChanged, this._onStageEstimateChanged);
        VoyageBestPracticeRoutesModel!.removeEventListener(SuggestedRouteStatusEvents.JobProgressChanged, this._onJobProgressChanged);
        this._clearCountdown();
    }
   
    async firstUpdated() {
        this._isOOREnabled = VoyageBestPracticeRoutesModel!.isOpenOceanRouteEnabled();
        await this._checkIfBPRisAvailable(this._scheduleId);

        // need to allign the approved route as selectedRoute , 
        //to show that as seelcted in the initial load

        await this._allignSelectedIndexToCurrentSelected()
        await this._showAcceptedWrAdviceReminder()
    }

    private async _showAcceptedWrAdviceReminder() {
        if (!this._plan) return;

        const acceptedWrRoute = this._plan.routes.find(route =>
            route.routeCreatedBy === 'WR' &&
            route.weatherRoutingInfo?.status === WRStatus.Accept
        );
        const approvedRoute = this._plan.routes[this._plan.selectedRouteIndex];

        // An accepted WR route is only finally accepted after it is approved and
        // sent. Do not interrupt the view when that route is already approved.
        if (!acceptedWrRoute || approvedRoute?.routeId === acceptedWrRoute.routeId) return;

        const dialog = VoyageDialogPopupManager.createDialog({
            headerText: 'Existing WNI Advice Detected',
            bodyText: 'You have already accepted the WNI Advice. Would you like to continue with it?',
            acceptButtonText: 'Yes, I would',
            rejectButtonText: 'No',
            noCloseButton: true,
        });
        const response = await dialog.getResponse();

        if (response === 'accept') {
            // Accepting the guidance does not finally accept or select a route.
            // The user must remain in Suggested Routes and complete the workflow
            // through Passage Plan -> Approve & Send.
            this._plan.status = 'planning';
            await VesselPlanningModel!.setPlan(this._scheduleId, this._plan, false);
            this.requestUpdate();

            const guidanceDialog = VoyageDialogPopupManager.createDialog({
                headerText: 'Weather Routing Advice Accepted',
                bodyText: `You have accepted the WNI Weather Routing advice. Please either:

Approve and submit the WNI route, or
Adjust your route to align with the WNI advice, then approve and submit it.

Your current route is now marked as Unapproved. Approving a route will submit it to WNI and complete the Weather Routing process.`,
                acceptButtonText: 'OK',
                noCloseButton: true,
            });
            await guidanceDialog.getResponse();
        } else if (response === 'reject') {
            await this._onDismissAdviceClicked(acceptedWrRoute.routeId);
        }
    }

    private _showLoader() {
        this._loading = true;
    }

    private _hideLoader() {
        this._loading = false;
    }

    private async _allignSelectedIndexToCurrentSelected(){
        if(!this._plan) {
            return ;
        }

        if(this._plan.routes[this._plan.selectedRouteIndex]?.routeId) {
        this._currentSelectedRouteId = this._plan?.routes[this._plan?.selectedRouteIndex].routeId;
        this._plan.currentSelectedRouteId = this._currentSelectedRouteId;
        const imo = isVesselOnCloud ? VoyageImoModel!.imo! : (<any>window)["appenv"].vesselIMONumber;
        this._updateShallowSoundingsAlert(imo, this._plan.routes[this._plan.selectedRouteIndex]);
        await VesselPlanningModel!.setPlan(this.scheduleId, this._plan!, false);
        this.requestUpdate();
        }
   }

    private _renderRetryBprModal(e: any) {
        const detail = (<CustomEvent>e).detail;
        this._bprJobError = detail.errorMessage ||
            'We encountered an unexpected issue while generating your route. Please try again.';
        this._clearCountdown();
        this.requestUpdate();
    }

    private async _renderOorFailedModal(e: Event) {
        const detail = (<CustomEvent>e).detail;
        const job = detail.job;

        this.showBprLoader = false;
        this._hideBprRoute = false;
        this._clearCountdown();
        this.requestUpdate();

        const dialog = VoyageDialogPopupManager.createDialog({
            headerText: "Open Ocean calculation failed",
            bodyText: `We were unable to calculate an Open Ocean Route for this voyage.\n\nClick "Download logs" to save the calculation log.`,
            acceptButtonText: "Download logs",
            rejectButtonText: "Close",
            isError: true,
        });

        const response = await dialog.getResponse();
        if (response === "accept") {
            downloadJobLog(job, `open-ocean-job-${job?.id ?? "log"}.json`);
        }
    }

    private async _checkIfBPRisAvailable(scheduleId: string, bprOptimizedLength?: number, ukcFailedRoutesLength?: number, bprGotUpdated = false) {
        
         this._plan = await VesselPlanningModel!.getCurrentPlan(scheduleId);

        if (!this._plan) {
            return
        }
        const isBprAvailable = VoyageBestPracticeRoutesModel!.getBPRAvaliabilityPerSchedule(scheduleId, this._plan.departureTerminalCode, this._plan.arrivalTerminalCode)

        const route = this._plan.routes.find(r => r.routeCreatedBy === 'system' && r.uiType !== 'OOR');
        if (!route) {
            // VoyageBestPracticeRoutesModel!.getAutoRoute(this._plan);
            this._isBestPracticeRouteAvailable = false;
        } else {
            this._isBestPracticeRouteAvailable = true;
        }


        if(route) {
            this.showBprLoader = false;
            this._clearCountdown();
        } else if (bprOptimizedLength && ukcFailedRoutesLength && bprOptimizedLength === ukcFailedRoutesLength) {
            this.showBprLoader = false;

            VoyageDialogPopupManager.createDialog({
                headerText: "Failed to fetch Star Route due to UKC failure",
                bodyText: "We are unable to fetch Star Route for this schedule as the routes are failing UKC Validation.",
                acceptButtonText: "Ok",
            });

        }
        this.showBprLoader = (isVesselOnCloud ? (isOnline() && isBprAvailable && !bprGotUpdated) : (isBprAvailable && !bprGotUpdated)) ? true : false; 

        if(bprGotUpdated) {
            // Keyed on "did the recalc settle", not bprOptimizedLength - a zero-result recalc must still clear this.
            this._hideBprRoute = false;
            this._clearCountdown();
        }

        // Only evaluate once the recalculation has fully settled (_hideBprRoute cleared above),
        // not against the stale routes still in this._plan while a recalculation is in flight.
        this._updateStarRouteUkcWarning();

        return route ? 'bprloaded' : (isBprAvailable && !bprGotUpdated) ? 'bprnotloaded' : 'bprnotavailable';
    }

    private _clearCountdown() {
        if (this._countdownInterval) {
            clearInterval(this._countdownInterval);
            this._countdownInterval = undefined;
        }
        this._remainingSeconds = null;
        this._stageEstimate = null;
    }

    private _onStageEstimateChanged(event: Event) {
        const customEvent = event as CustomEvent;
        const stageEstimate: StageEstimate = customEvent.detail;
        this._startCountdown(stageEstimate);
    }

    private _normaliseProgressStep(statusDetails: string): BprProgressStep {
        const routeProgress = statusDetails.match(/^(.*?)(\d+\/\d+)\s+routes?$/i);
        if (routeProgress) {
            const title = routeProgress[1].trim();
            return {
                key: title.toLowerCase(),
                title,
                detail: `${routeProgress[2]} routes completed`,
            };
        }

        const calculatingPower = statusDetails.match(/^Calculating power for\s+(.+)$/i);
        if (calculatingPower) {
            return {
                key: 'calculating power',
                title: 'Calculating power',
                detail: calculatingPower[1],
            };
        }

        return {
            key: statusDetails.toLowerCase(),
            title: statusDetails,
        };
    }

    private _onJobProgressChanged(event: Event) {
        const result = (event as CustomEvent<BprJobResult>).detail;
        const status = result?.status?.toLowerCase();

        if (status === 'failed' || status === 'failedpendingretry') {
            this._bprJobError = result.errorDetails?.hydraErrorBody?.message ||
                result.statusDetails ||
                'We encountered an unexpected issue while generating your route. Please try again.';
            this._clearCountdown();
            this.requestUpdate();
            return;
        }

        if (!result?.statusDetails || status === 'complete') {
            return;
        }

        const step = this._normaliseProgressStep(result.statusDetails);
        const existingIndex = this._bprProgressSteps.findIndex(item => item.key === step.key);
        if (existingIndex >= 0) {
            this._bprProgressSteps = this._bprProgressSteps.map((item, index) => index === existingIndex ? step : item);
        } else {
            this._bprProgressSteps = [...this._bprProgressSteps, step];
        }
        this.requestUpdate();
    }

    private _retryBprJob() {
        if (!this._plan) return;
        this._bprJobError = null;
        this._bprProgressSteps = [];
        this._isProgressExpanded = false;
        VoyageBestPracticeRoutesModel!.getRankedBPRsForSchedule(this._plan, true);
    }

    private _startCountdown(stageEstimate: StageEstimate) {
        this._clearCountdown();
        this._stageEstimate = stageEstimate;
        this._updateRemainingSeconds();
        if (this._remainingSeconds !== null && this._remainingSeconds > 0) {
            this._countdownInterval = setInterval(() => this._updateRemainingSeconds(), 1000);
        }
    }

    private _updateRemainingSeconds() {
        if (!this._stageEstimate || this._stageEstimate.expectedSeconds == null) {
            this._remainingSeconds = null;
            return;
        }
        const startedAt = new Date(this._stageEstimate.startedAt).getTime();
        const expectedMs = this._stageEstimate.expectedSeconds * 1000;
        const elapsed = Date.now() - startedAt;
        const remaining = Math.ceil((expectedMs - elapsed) / 1000);
        if (remaining <= 0) {
            this._remainingSeconds = 0;
            if (this._countdownInterval) {
                clearInterval(this._countdownInterval);
                this._countdownInterval = undefined;
            }
        } else {
            this._remainingSeconds = remaining;
        }
        this.requestUpdate();
    }

    private _showBprJobCompletionSummary(errorDetails?: BprJobErrorDetails) {
        if (!errorDetails) {
            return;
        }

        const routeChecks = errorDetails.routeChecks ?? null;
        // OOR failures can contain the complete worker response (UUID pairs and serialized
        // validation errors). The detailed payload remains available from the download-log
        // dialog; rendering it in this fixed-width card causes the suggested-routes UI to
        // overflow and duplicates that dialog.
        const errorMessage = errorDetails.hydraErrorBody?.message ||
            (errorDetails.oorError ? 'Open Ocean route calculation failed. Star Routes that passed validation are still available.' : null);

        if (!routeChecks && !errorMessage) {
            return;
        }

        this._bprRouteChecks = routeChecks;
        this._bprCalculationError = errorMessage;
        this._showBprResultSummary = true;
        this.requestUpdate();

        setTimeout(() => {
            this._showBprResultSummary = false;
            this.requestUpdate();
        }, 3000);
    }

    @property ({ attribute: false }) private _showSortLoader: boolean = false


    private async _selectedRouteChanged(event: { target: { value: string; }; }) {

        this._showSortLoader = true;
        const selectedElement = ElementMapper[event.target.value];
        this._selectedRoute = event.target.value;
        const routesCardList = [...this._routes];
        routesCardList.sort((a, b) => {
            const parseValue = (item: any) => {
                if (item && item.calculatedValues && item.calculatedValues[selectedElement]) {
                    const parsed = parseFloat(item.calculatedValues[selectedElement]);
                    return isNaN(parsed) ? -Infinity : parsed;
                }
                return -Infinity;
            };
        
            // Get the parsed values for both items
            const ElementA = parseValue(a);
            const ElementB = parseValue(b);
        
            // Perform the comparison for ascending order
            return ElementA - ElementB;
        })

        const routeIds = routesCardList.map(r => r.route?.routeId);

        //update the plan routes in same index as this.routes
        if(this._plan) {
            this._plan.routes = this._plan.routes.sort((a, b) => {
                return routeIds.indexOf(a.routeId) - routeIds.indexOf(b.routeId);
            });
        }

       await VesselPlanningModel!.setPlan(this.scheduleId, this._plan!, false);
       this._showSortLoader = false;
       this.requestUpdate();
    }
    private _selectedOnes: HTMLElement | null = null;

    private _selectAlignedToRoute(e: Event) {
        const target = e.currentTarget as HTMLElement;

        if (this._selectedOnes) {
            this._selectedOnes.classList.remove('selected');
        }

        target.classList.add('selected');

        this._selectedOnes = target;

        this.requestUpdate();

}

    private _renderEachCard(){
        return html`
            <div class="contanier-route-modal">
                ${                    
                    this._routes.map((route, index) => {
                    const routeId = route.route?.routeId ?? '';
                    if(route.route != null && route.route.routeCreatedBy === "system" ) {
                        return html`
                        <div @click=${(e:Event)=>{
                           this._selectAlignedToRoute(e);}} 
                            id=${routeId} 
                            class="route-card-items" 
                            style="--selected-background-color: ${getBackgroundColor(index)}; --selected-border-color: ${getBorderColor(index)};" >
                            ${this._renderLegendAlignStarRoute(routeId, index)}
                        </div>
                        `
                    }
                })}
            </div>`
    }

    private _renderBprProgressLoader() {
        if (this._bprJobError) {
            return html`
                <div class="bpr-loader bpr-loader-error" role="alert">
                    <div class="bpr-error-icon">${SvgIcons.lightExclamationCircle}</div>
                    <p>${this._bprJobError}</p>
                    <button class="bpr-retry-button" type="button" @click=${this._retryBprJob}>Try Again</button>
                </div>
            `;
        }

        return html`
            <div class="bpr-loader bpr-progress-loader">
                ${this._remainingSeconds != null ? html`
                    <div class="bpr-estimate">
                        <span class="bpr-clock" aria-hidden="true"></span>
                        About ${formatCountdown(this._remainingSeconds)} remaining
                    </div>
                ` : nothing}
                <button
                    class="bpr-progress-toggle"
                    type="button"
                    aria-expanded=${this._isProgressExpanded}
                    @click=${() => this._isProgressExpanded = !this._isProgressExpanded}
                >
                    <span class="bpr-header-loader">
                        <mc-loading-indicator
                            fit="small"
                            label="Route generation in progress"
                            hiddenlabel
                        ></mc-loading-indicator>
                    </span>
                    <span>Route Generation In-progress</span>
                    <span class="bpr-chevron ${this._isProgressExpanded ? 'expanded' : ''}" aria-hidden="true"></span>
                </button>
                ${this._isProgressExpanded ? html`
                    <mc-step-indicator class="bpr-progress-timeline" orientation="vertical" fit="small">
                        ${this._bprProgressSteps.map((step, index) => {
                            const isCurrent = index === this._bprProgressSteps.length - 1;
                            return html`
                                <mc-step-indicator-item state=${isCurrent ? 'current' : 'completed'}>
                                    <div class="bpr-step-copy">
                                        <div>${step.title}</div>
                                        ${step.detail ? html`<small>${step.detail}</small>` : nothing}
                                    </div>
                                </mc-step-indicator-item>
                            `;
                        })}
                    </mc-step-indicator>
                ` : nothing}
            </div>
        `;
    }

    render() {
        if (!this._plan) {
            return html``;
        }
        const ifBprRouteAvaiableinPlan = this._plan.routes.find(r => r.routeCreatedBy === 'system' && r.uiType !== 'OOR');
        const fetchingBprDisabled = starRouteFetchDisabled(this._plan.etd);
        const bprUpdationLoader = ifBprRouteAvaiableinPlan && this._hideBprRoute && this.showBprLoader;
        const disableClass = (this.isDisabled) ? "disable" : "";

        return html`
            <div class="container">
                <div class="scheduleinfo">
                    <div class="scheduleborder" column="1"></div>
                    <div class="scheduleborder" column="2"></div>
                    <div class="schedulecell" data-test="dep-port" legendHeader column="1" row="1">Departure: ${TerminalsModel!.getCity(this._plan.departureTerminalCode) || this._plan.departureTerminalCode}</div>
                    <div class="schedulecell" data-test="arr-port" legendHeader column="2" row="1">Arrival: ${TerminalsModel!.getCity(this._plan.arrivalTerminalCode) || this._plan.arrivalTerminalCode}</div>
                    <div class="schedulecell" legend column="1" row="2">${GetFormattedDate(this._plan.etd)} UTC</div>
                    <div class="schedulecell" legend column="2" row="2">${GetFormattedDate(this._plan.eta)} UTC</div>
        		</div>
                <div class="sort-routes-title">Sorts routes by:</div>
                <div class="scheduleinfo route-card">
                    <div class="scheduleborder" column="1"></div>
                    <div class="scheduleborder" column="2"></div>
                    <div class="schedulecell" data-test="dep-port" legendHeader column="1" row="1">
                        <select id="Sort-routes"
                            .value=${this._selectedRoute}
                            @input=${(evt: { target: { value: string; }; }) => this._selectedRouteChanged(evt as any)}>
                            ${DropDown_Options.map((option) => {
                                return html`<option value=${option}>${option}</option>`
                                }
                            )}
                         </select>
                    </div>

                    <div class="schedulecell" data-test="arr-port" legendHeader column="2" row="1">                    
                        <mc-button ?disabled=${this.isDisabled} class=${disableClass} appearance="neutral" width="full-width" id="weatherLimits" fit="small" @click=${() => this.dispatchEvent(new Event('weather-limits-click'))}>
                            Add Weather Limits
                    </mc-button>
                </div>
                 </div>
        		</div>
                ${                    
                    (this.showBprLoader && !ifBprRouteAvaiableinPlan && !fetchingBprDisabled) ? html`
                    ${this._renderBprProgressLoader()}
                    ` : html``
                }

                ${
                    (bprUpdationLoader) ? html`
                    ${this._renderBprProgressLoader()}
                    ` : html``
                }

                ${
                    this._showBprResultSummary ? html`
                    <div class='bpr-loader bpr-result-summary'>
                        ${ this._bprCalculationError ? html`<p class="bpr-error">${this._bprCalculationError}</p>` : html``}
                        ${ this._bprRouteChecks ? html`
                            <p>Star Routes calculated: ${this._bprRouteChecks.totalStarRoutes}</p>
                            <p>Passed heavy weather check: ${this._bprRouteChecks.heavyWeatherPassed}</p>
                            <p>Passed parametric roll check: ${this._bprRouteChecks.parametricRollPassed}</p>
                            <p>Passed UKC check: ${this._bprRouteChecks.ukcPassed}</p>
                        ` : html``}
                    </div>
                    ` : html``
                }


                ${this._showSortLoader ? html`
                <div class='bpr-loader'>
                        <voyage-spinner></voyage-spinner>
                        <p>Routes are being sorted for you...</p>
                    </div>
                ` : html`
                <div class="contanier-route">
                    ${                    
                        this._routes.map((route, index) => {
                        const routeId = route.route?.routeId ?? '';
                        // With const_pow_endpoint_v2 the restrictions come from the analytics
                        // constant-power calculation and the action opts out of them
                        // (route_info.disableWhaleZoneSpeedRestrictions). Without the flag the old
                        // action stamps the zones onto the waypoints in the browser instead
                        // (route_info.whaleZonesApplied), so each mode reads its own state.
                        const whaleZoneSpeedRestrictionsDisabled = this._constPowEndpointV2Enabled
                            ? (route.route?.route_info?.disableWhaleZoneSpeedRestrictions ?? false)
                            : (route.route?.route_info?.whaleZonesApplied ?? false);
                        const shouldRenderWRActions = this._showActionsForWeatherRoute && route.route?.routeCreatedBy === 'WR' && route.route?.weatherRoutingInfo?.status !== WRStatus.Reject && this._plan?.currentSelectedRouteId !== routeId;
                        const currentApprovedRouteId = this._plan?.status === 'approved' ? this._plan?.routes[this._plan?.selectedRouteIndex]?.routeId : null;
                        const hideBprRoute = route.route?.routeCreatedBy === 'system' && route.route?.uiType !== 'OOR' && this._hideBprRoute && route.route.routeId !== currentApprovedRouteId;
                        if(route.route != null && !hideBprRoute) {
                            return html`
                            <div class="route-card-item ${this._currentSelectedRouteId === routeId ? 'selected' : ''}" style="--selected-background-color: ${getBackgroundColor(index)}; --selected-border-color: ${getBorderColor(index)};" >
                                ${this._renderLegend(routeId, index)}
                                ${this._currentSelectedRouteId !== routeId ? shouldRenderWRActions ? this._renderRouteActionsForWeatherRoute(index, routeId) :  (route.status !== 'calculating')? html`${this._renderRouteActions(index, routeId, whaleZoneSpeedRestrictionsDisabled)}`: (isOnline() ? "": html`${this._renderRouteActions(index, routeId, whaleZoneSpeedRestrictionsDisabled)}`):
                                 html`${this._renderRouteActionsForSelectedRoute(index, routeId, whaleZoneSpeedRestrictionsDisabled)}`}
                            </div>
                            `
                        }
                    })}
                </div>` 
                }
                 
                <div class="sticky-footer">
                    <div class="accordion" id="planningAccordion">
                        <div class="accordion-content" id="planningContent">
                            ${this._renderPlanningActions()}
                        </div>
                    </div>
                </div>
        </div>
        ${this.showDeleteToast ? this._renderDeleteSuccessToast() : nothing}
        ${this._showAlignStarRouteModal ? this._renderAlignStarRouteModal() : nothing}

       `;
    }

    toggleAccordion() {
        const content = this.shadowRoot?.getElementById('planningContent');
        if (!content) return;
        content.style.display = content.style.display === 'none' ? 'block' : 'none';
        this.isAccordianOpen = !this.isAccordianOpen;
        this.requestUpdate();
    }


    @property({attribute: false}) private _selectedIndex: number = -1;
    @property({attribute: false}) private _currentSelectedRouteId: string = '';
    @property({attribute: false}) private _plan: VoyagePlan|null = null;
    // Plan might not contain selected route index because it is not persisted as 
    // vessel plans api cannot handle a selected route that has failed.
    // But user might still have selected a failed route in the UI.
    // So this._selectedUiRoute is to enable UI (e.g. route editor button) when user has selected a failed route.
    @property({attribute: false}) private _selectedUiRouteIndex: number = -1;
    @property({attribute: false}) private _selectedRoute: string = "fuel";
    @property({attribute: false}) private _showCompareTable: boolean = false;
    @property({attribute: false}) private _showMaxRouteDialog: boolean = false;
    @property({attribute: false}) private _disableSelectWr: boolean = false;
    @property ({ attribute: false }) private _showActionsForWeatherRoute: boolean = true;

    @property({ type: Function }) setStarRouteLayerVisibility!: (starRouteID: string, routeID: string) => void;

    private _scheduleId: string = "";
    private _routes: UIRouteWithCalculatedValues[] = [];
    // While a failed route is selected, the Passage Plan is in 'offline mode', so plan is not saved in backend. Approve button is disabled as well.
    private _nonHydraCalculatedRouteSelected: FailedUIRouteWithMetadata|null = null;
    private _showAlignStarRouteModal: boolean = false;
    
    private async _onPassagePlanClicked() {
        if (!this._plan || !this._plan.currentSelectedRouteId) {
            return;
        }
        // The route's precautionary zone warnings have to be reviewed first.
        if (this._needsWarningsReview(this._plan.currentSelectedRouteId)) {
            return;
        }
        // check if route is valid
        const currentSelectedRoute = this._plan.routes.find(r => r.routeId === this._plan?.currentSelectedRouteId);
        if (!currentSelectedRoute) {
            return;
        }

        if(!checkifValidRoute(currentSelectedRoute)) {
            const errorPopup = await VoyageDialogPopupManager.createDialog({
                headerText: "The selected Route contains fewer than 2 pilot waypoints.",
                bodyText: "All plans require at least 2 waypoints marked as 'Pilot' waypoints to correctly calculate a speed profile.\nIf your plan starts or ends in an area where no pilot is required, \n set the first or last waypoint as a pilot waypoint (e.g., arriving or departing from an anchorage)",
                acceptButtonText: "Edit Route",
                rejectButtonText: "Cancel"
            });

            const res = await errorPopup.getResponse();
            if (res === "accept") {
                await this._editRoute(currentSelectedRoute.routeId);
            } 

            return;
        }
        
        if (this._plan && this._plan.currentSelectedRouteId) {
            const currentSelectedRouteIndex = this._plan.routes.findIndex(r => r.routeId === this._plan?.currentSelectedRouteId);
            const passagePlan = this._plan.routes[currentSelectedRouteIndex].passagePlan;

            if (passagePlan && !isVesselOnCloud) {
                // commenting this as we are handling weather routing in an differnet way now
                // await handleWeatherRouting(this._plan);
            }
        }

        if (this._nonHydraCalculatedRouteSelected) {
            this.dispatchEvent(new CustomEvent('passage-plan-click', {detail: { nonHydraCalculatedRoute: this._nonHydraCalculatedRouteSelected?.route }}));
            return;
        }
        this.dispatchEvent(new Event('passage-plan-click'));
    }

    private _renderLegend(routeId: string, index: number): TemplateResult {
        const calculatedValues: CalculatedValues = this._getCalculatedValues(routeId, index);
        const routeIconColor = getBorderColor(index) ?? '#000000';
        const routeObject = this._routes.find(route => route.route?.routeId === routeId);
        if(!routeObject) return html``;
        const isFailed = routeObject?.status === 'failed';
        const isCalculating = routeObject?.status === 'calculating';
        const hiddenRoute = VoyageRoutingModel!._getHiddenRoutes()
        const isRouteHidden = hiddenRoute.includes(routeId);
        const selectedRouteId = this._plan?.routes[this._plan?.selectedRouteIndex]?.routeId ?? '';
        const showDeleteOption = showDeleteIcon(selectedRouteId, routeId, calculatedValues.name, routeObject?.route?.routeCreatedBy);
        const routeDisplayName = (routeObject?.route?.routeCreatedBy === 'system' && this._plan?.currentSelectedRouteId === routeObject.route.routeId) ? 'My StarRoute' : calculatedValues.name;
        const isStarRoute = routeObject?.route?.routeCreatedBy === 'system';
        const name = isStarRoute ? `${routeObject?.route?.name}` : routeObject?.route?.name ? `${routeObject?.route.name}` : `Own route ${index + 1}`;
        
        return html`
            <div class="route-tile-delete">
                <mc-tooltip position="top-center">
                    <div class="route-name" slot="trigger">${routeDisplayName}</div>
                    <div class="route-tooltip-text">${routeDisplayName}</div>
                </mc-tooltip>
                <div class="route-icon">${SvgIcons.routeIcon(routeIconColor)}</div>
                <div class="route-hide-show">
                <mc-switch
                    label="Map view"
                    name="map-view"
                    ?checked=${!isRouteHidden}
                    @change=${(event: Event) => this._handleMapHideAndShow(event, routeId)}>
                </mc-switch>
                </div>
                ${showDeleteOption  ? html`<div class="delete-icon" @click=${(event: Event) => this._handleDeleteIconClick(event, routeId)}>
                    ${SvgIcons.deleteIcon}
                </div>` : nothing }
                
            </div>

            ${(isVesselOnCloud && !isOnline() && routeObject.route?.recalcNeeded) ? html`<div class="offline-routes-container"> <div class="exclamation-icon">${SvgIcons.lightExclamationCircle}</div>Once online, below data will be calculated</div>`: nothing }
    
            ${(isVesselOnCloud && !isOnline() && !isStarRoute) ? this._renderSummary(calculatedValues, routeObject?.route) :
                isFailed? this._renderFailedContainer() :
                isCalculating ? this._renderLoaderContainer() :

              this._renderSummary(calculatedValues, routeObject?.route)}
        `;
    }
    private _renderLegendAlignStarRoute(routeId: string, index: number): TemplateResult {
        const calculatedValues: CalculatedValues = this._getCalculatedValues(routeId, index);
        const routeIconColor = getBorderColor(index) ?? '#000000';
        const routeObject = this._routes.find(route => route.route?.routeId === routeId);
        if(!routeObject) return html``;
        const isFailed = routeObject?.status === 'failed';
        const isCalculating = routeObject?.status === 'calculating';

        return html`
            <div class="route-tile-delete">
                <div class="route-name">${calculatedValues.name}</div>
                <div class="route-icon">${SvgIcons.routeIcon(routeIconColor)}</div>
            </div>    
            ${isFailed ? this._renderFailedContainer() :
              isCalculating ? this._renderLoaderContainer() :
              this._renderSummary(calculatedValues, routeObject?.route)}
        `;
    }
   
    private _renderFailedContainer(): TemplateResult {
        return html`
            ${ (isVesselOnCloud && !isOnline()) ? html `<div class="failed-container">
                <div class="exclamation-icon">${SvgIcons.lightExclamationCircle}</div>
            </div>`: html`<div class="failed-container">
            <div class="exclamation-icon">${SvgIcons.lightExclamationCircle}</div>
            <div class="failed-route">Failed calculation,<br>please try edit route and save.</div>
        </div>` }`;
    }
    
    private _renderLoaderContainer(): TemplateResult {
        return html`${ (isVesselOnCloud && !isOnline()) ? html `<div class="loader-container">
                <div class="exclamation-icon">${SvgIcons.lightExclamationCircle}</div>
            </div>` : 
            html `<div class="loader-container">
                <voyage-spinner class="loader"></voyage-spinner>
            </div>` }`;
    }
    
    private _handleDeleteIconClick(event: Event, routeId: string): void {
        event.stopPropagation();
        this.renderDeleteModal(routeId);
    }

    private _handleMapHideAndShow(event: Event, routeId: string): void {
        event.stopPropagation();
        VoyageRoutingModel!._setRouteViewStatus(routeId, this._scheduleId,  (event.target as HTMLInputElement).checked);
    }
    
    
    private async renderDeleteModal(routeId: string) {
        const dialog = await VoyageDialogPopupManager.createDialog({
            headerText: "Delete Route",
            bodyText: "You are about to delete the current route.\nplease confirm if you want to progress with the deletion.",
            acceptButtonText: "Confirm",
            rejectButtonText: "Cancel"
        });
        const response = await dialog.getResponse();
        if (response === "accept") {
            this._deleteRoute(routeId);
        }
    }


    private showDeleteToast = false;


    private _renderDeleteSuccessToast() {
        setTimeout(()=>{
            this.showDeleteToast = false
            this.requestUpdate()
        }, 10000)
        return html`
            <div class="success">
                <div class="icon">${SvgIcons.tickMark}</div>
                <div class="text">Route has been deleted.</div>
                <div class="icon close" @click=${() => {
                    this.showDeleteToast = false;
                    this.requestUpdate();
                    }}>${SvgIcons.lightTimes}</div>
            </div>
        `;
    }
    // Refactored the old code and added type for calculatedValues
    private _renderSummary(calculatedValues: CalculatedValues, route?: VoyageRoute | null) {
        const summaryRows = [
          { label: "Total Bunker Consumption", value: calculatedValues.fuel || "---" },
          { label: "Distance", value: calculatedValues.distance || "---"},
          { label: "Distance Pilot to Pilot", value: calculatedValues.distancePilotToPilot || "---"},
          { label: "Average Speed", value: calculatedValues.avgSpeed || "---"},
          { label: "Avg Speed Pilot/Pilot", value: calculatedValues.avgSpeedPilotToPilot || "---"},
        ];

        const weatherRows = [
            { label: "Maximum wind speed (10 m)", value: calculatedValues.maxwind || "---"},
            { label: "Maximum wave height", value: calculatedValues.maxwave || "---"},
            { label: "Maximum swell height", value: calculatedValues.maxswell || "---"},
            { label: "In severe weather for", value: "---" } // Assuming fixed value as '---'
        ]

        const crossings = route ? getCrossingZoneCount(route.route_geometry as any[]) : 0;
        const routeId = route?.routeId ?? '';

        // Running row index so inserting the Precautionary Zones row can't desync the grid.
        let row = 0;
        const nextRow = () => ++row;
        const header = (label: string) =>
            html`<div class="cell row${nextRow()}" legendHeader>${label}</div>`;
        const dataRow = (label: string, value: any) => {
            const r = nextRow();
            return html`
                <div class="cell row${r}" legend>${label}</div>
                <div class="cell2 row${r}" legend>${value}</div>`;
        };

        return html`
            <div class="route-data">
                ${header('Summary')}
                ${summaryRows.map(r => dataRow(r.label, r.value))}
                ${this._renderNoGoZonesRow(crossings, routeId, nextRow())}
                ${header('Weather')}
                ${weatherRows.map(r => dataRow(r.label, r.value))}
                ${header('Route rating')}
                <div class="cell row${nextRow()}" legendHeader></div>
            </div>
        `;
    }

    private _renderNoGoZonesRow(crossings: number, routeId: string, rowNum: number) {
        return html`
            <div class="cell row${rowNum}" legend>
                Route Warnings
                ${this._renderWarningsReviewTag(routeId)}
            </div>
            <div class="cell2 row${rowNum}" legend>
                ${crossings} Crossing${crossings === 1 ? '' : 's'}
                ${crossings > 0
                    ? html`<span class="view-more" @click=${() => this._onViewNoGoZones(routeId)}>(View more)</span>`
                    : nothing}
            </div>`;
    }

    // "View more" opens the route editor's review on the route's precautionary zones - the same
    // place "Edit route" leads to, minus the align-with-star-route prompt, since reviewing warnings
    // is not an edit.
    private _onViewNoGoZones(routeId: string) {
        this._editRoute(routeId);
    }

    /**
     * ==================================================================================
     * ROUTE WARNINGS REVIEW (const_pow_endpoint_v2 only)
     * ==================================================================================
     *
     * A route that crosses precautionary zones has to have those crossings reviewed in the route
     * editor before it can be used: until the user acknowledges them with "Mark as reviewed" the
     * route shows a "Needs Review" tag and both "Select route" and "Passage Plan" stay disabled.
     * The acknowledgement lives on route_info.routeWarningsReviewed and survives a recalculation
     * only while the route keeps crossing the exact same zone points.
     */
    private _needsWarningsReview(routeId: string): boolean {
        if (!this._constPowEndpointV2Enabled) {
            return false;
        }

        const route = this._routes.find(r => r.route?.routeId === routeId)?.route;
        return routeNeedsWarningsReview(route);
    }

    // The review's state on the Route Warnings row: red "Needs Review" until the user acknowledges
    // the crossings in the route editor, green "Reviewed" afterwards. The acknowledgement is
    // persisted on the route, so it reads the same after leaving and coming back, and only a route
    // change that moves the crossings puts the row back to "Needs Review".
    private _renderWarningsReviewTag(routeId: string) {
        if (this._needsWarningsReview(routeId)) {
            return html`<span class="needs-review" data-test="needs-review">
                ${SvgIcons.lightExclamationCircle}Needs Review</span>`;
        }

        if (!this._warningsReviewed(routeId)) {
            return nothing;
        }

        return html`<span class="needs-review" reviewed data-test="reviewed">
            ${SvgIcons.lightCheckCircle}Reviewed</span>`;
    }

    private _warningsReviewed(routeId: string): boolean {
        if (!this._constPowEndpointV2Enabled) {
            return false;
        }

        const route = this._routes.find(r => r.route?.routeId === routeId)?.route;
        return routeWarningsReviewed(route);
    }

    // Opens the route editor for a route from outside the component (the map's precautionary zone
    // markers, which have no other way into the review).
    async openRouteEditorForRoute(routeId: string): Promise<void> {
        await this._editRoute(routeId);
    }

    // Wraps an action that the review blocks, so hovering the disabled button explains why. The
    // button is returned untouched once the route needs no review.
    private _renderWarningsReviewGate(routeId: string, action: TemplateResult, fullWidth: boolean = false): TemplateResult {
        if (!this._needsWarningsReview(routeId)) {
            return action;
        }

        return html`
            <mc-tooltip position="top-center" class="review-gate-tooltip" ?full=${fullWidth}>
                <div class="review-gate" slot="trigger">${action}</div>
                <div class="route-tooltip-text">
                    This route contains Route Warnings. Review the warnings and, where necessary,
                    amend the route before proceeding to Passage Plan and submitting the route.
                </div>
            </mc-tooltip>
        `;
    }

    private _renderSummaryOffline() {
        return html`
        <div class="offline-routes-container">
            <div>
                <div class="exclamation-icon">${SvgIcons.lightExclamationCircle}</div>
                Once online, below data will be calculated
            </div>
            ${
                this._renderSummary({} as CalculatedValues)
            }
        </div>`;
        
    } 

    private _renderRouteActions(index:number, routeId: string, whaleZoneSpeedRestrictionsDisabled: boolean | false) {
        const disableClass = (this.isDisabled) ? "disable" : "";
        return html`
        <div class = "action-wrapper  bottom-row ">
            <mc-button appearance="neutral" fit="small" @click=${(event:any) => this._onRouteEditorClicked(index,event, routeId)}>Edit route</mc-button>
            ${this._renderWarningsReviewGate(routeId, html`
                <mc-button appearance="neutral" fit="small" data-test="select-route" ?disabled=${this._needsWarningsReview(routeId)}
                           @click=${(e: Event)=>this._selectRouteId(index, routeId)}>Select route</mc-button>
            `)}
            ${this._constPowEndpointV2Enabled
                ? html`<mc-button appearance="neutral" fit="small" class=${disableClass} ?disabled=${this.isDisabled || whaleZoneSpeedRestrictionsDisabled} @click=${(e: Event)=>this._disableWhaleZoneSpeedRestrictions(index)}>${whaleZoneSpeedRestrictionsDisabled ? "Whale zone disabled": "Disable whale zone"}</mc-button>`
                : html`<mc-button appearance="neutral" fit="small" class=${disableClass} ?disabled=${this.isDisabled || whaleZoneSpeedRestrictionsDisabled} @click=${(e: Event)=>this._applyZones(index, new WhaleZonesUtilities())}>${whaleZoneSpeedRestrictionsDisabled ? "Whale zones applied": "Apply whale zones"}</mc-button>`}
        </div>
        `;
    }

    private _renderRouteActionsForSelectedRoute(index:number, routeId: string, whaleZoneSpeedRestrictionsDisabled: boolean | false) {
        return html`
            ${this._loading && isOnline() ? html`
                <div class= "loader">
                <div class="loadingOverlay">
                    <voyage-spinner></voyage-spinner>
                </div>
                </div>` : html`<div class="action-wrapper row13">
                <mc-button appearance="neutral" fit="small"  @click=${(event:any) => this._onRouteEditorClicked(index, event, routeId)}>Edit route</mc-button>
                <mc-button appearance="neutral" fit="small"  disabled>Selected Route</mc-button>
                ${this._constPowEndpointV2Enabled
                    ? html`<mc-button appearance="neutral" fit="small" ?disabled=${whaleZoneSpeedRestrictionsDisabled} @click=${(e: Event)=>this._disableWhaleZoneSpeedRestrictions(index)}>${whaleZoneSpeedRestrictionsDisabled ? "Whale zone disabled": "Disable whale zone"}</mc-button>`
                    : html`<mc-button appearance="neutral" fit="small" ?disabled=${whaleZoneSpeedRestrictionsDisabled} @click=${(e: Event)=>this._applyZones(index, new WhaleZonesUtilities())}>${whaleZoneSpeedRestrictionsDisabled ? "Whale zones applied": "Apply whale zones"}</mc-button>`}
            </div>
            <div class="action-wrapper row14">
                ${this._renderWarningsReviewGate(routeId, html`
                    <mc-button appearance="primary" fit="small" width="full-width" data-test="passage-plan"
                               ?disabled=${this._needsWarningsReview(routeId)}
                               @click=${this._onPassagePlanClicked} icon="clipboard-list-text">
                        Passage Plan
                    </mc-button>
                `, true)}
            </div>
            <div class="action-wrapper export-option bottom-row row15">
            ${ isVesselOnCloud ? html`
                <voyage-route-export show-above .editRouteFn=${this._editRoute}  .plan=${this._plan}></voyage-route-export>
                `
                :html`
                <voyage-route-export show-above .plan=${this._plan as any}></voyage-route-export>
                `
            }

            </div>`}
        `;
    }
    
    private async _onAcceptAdviceClicked(routeId: string, index: number) {
        // check if the approved route is already WR
        const wrRouteIndex = this._plan?.routes.findIndex(r => r.routeCreatedBy === 'WR' && r.routeId !== routeId);

        if(wrRouteIndex !== -1) {
            this._plan?.routes.splice(wrRouteIndex!, 1);
        }

        const currentRoute = this._plan?.routes.find(r => r.routeId === routeId);
        const currentRouteIndex = this._plan?.routes.findIndex(r => r.routeId === routeId);
        this._plan!.routes[currentRouteIndex!].weatherRoutingInfo!.status = WRStatus.Accept;
        this._clearWeatherRoutingActionNeededAlert();

        await this._selectRouteId(currentRouteIndex!, routeId);
    }

    private _showAdvice(wrId?: number){
        if(!wrId) {
          console.log('No WR ID provided');
          return;
        }
        this.dispatchEvent(new CustomEvent('show-advice', {detail: { showAdvice:true, scheduleId: this.scheduleId, wrId: wrId}}));
    }

    private _clearWeatherRoutingActionNeededAlert() {
        VesselAlertsModel!.removeAlert((<any>window)["appenv"].vesselIMONumber, `weather-routing-advice-action-needed-${this.scheduleId}`);
    }

    private async _onDismissAdviceClicked(routeId: string) {
        const wrRoute = this._plan?.routes.find(r => r.routeCreatedBy === 'WR' && r.routeId === routeId);
        const correlationId = wrRoute?.weatherRoutingInfo?.correlationId;
        VesselClfPopupModel!.setPopupVisibility('WrReject', this.scheduleId, this._plan?.departureTerminalCode!, this._plan?.arrivalTerminalCode!, this._plan?.id!, this._plan?.eta, this._plan?.etd, correlationId);
    }

    private async _onWRCLfPopupSubmitted(event: Event) {
        // adding status check if there is already a WR route present and 
        // if new advice is presented on dismissing the new advice we should remove the new WR advice
        const wrRoute = this._plan?.routes.find(r => r.routeCreatedBy === 'WR' && r?.weatherRoutingInfo?.status !== WRStatus.Accept)
            ?? this._plan?.routes.find(r => r.routeCreatedBy === 'WR' && r?.weatherRoutingInfo?.status === WRStatus.Accept);
        let isWeatherRouteUpdate = this._plan?.routes.find(r => r.routeCreatedBy === 'WR' && r?.weatherRoutingInfo?.status === WRStatus.Accept);
        const correlationId = wrRoute?.weatherRoutingInfo?.correlationId;
        if(wrRoute?.routeId) {
            this._plan!.status = 'planning';
            const currentSelectedRouteIndex = this._plan?.routes.findIndex(r => r.routeId === this._plan?.currentSelectedRouteId)
            if(currentSelectedRouteIndex !== undefined && currentSelectedRouteIndex !== -1) {
                 this._plan!.routes[currentSelectedRouteIndex].weatherRoutingInfo = {
                    ...wrRoute.weatherRoutingInfo,
                    required: true,
                    status: WRStatus.Reject,
                 };
            }
            await this._deleteRoute(wrRoute?.routeId);
        }

        const wrRejectedObject = {
            "scheduleId": this.scheduleId,
            "departureTerminalCode": this._plan?.departureTerminalCode,
            "arrivalTerminalCode": this._plan?.arrivalTerminalCode,
            "eta": this._plan?.eta,
            "etd": this._plan?.etd,
            "id": this._plan?.id,
            "isWeatherUpdate": isWeatherRouteUpdate ? true : false,
            'correlationId': correlationId,
            "reason": (event as CustomEvent).detail.reason,
            "comment": (event as CustomEvent).detail.comment
        }


        localStorage.setItem('wrRejected', JSON.stringify(wrRejectedObject));

        VesselAlertsModel!.addAlert((<any>window)["appenv"].vesselIMONumber, {
            message: `Counter Proposal Rejected`,
            id: UUID(),
            type: AlertType.CounterProposalNotification,
        })

        const remarks = `${wrRejectedObject.reason} - ${wrRejectedObject.comment}`;
        const auditId = this._plan?.audit_id;
        const weatherRoutingInfo: WeatherRoutingInfo = {
            ...wrRoute?.weatherRoutingInfo,
            audit_id: auditId,
            required: true,
            remarks: remarks,
        };

        // change the WR status to reject
        VoyageWeatherRoutingModel!.updateWRStatus((wrRoute?.weatherRoutingInfo?.id ?? 0).toString(), WRStatus.Reject, weatherRoutingInfo);
        this._clearWeatherRoutingActionNeededAlert();
    }

    private _onWRCLfPopupClosed() { 
    }

    private _renderRouteActionsForWeatherRoute(index:number, routeId: string) {
        const wrRouteId = this._plan?.routes.find(r => r.routeCreatedBy === 'WR' && r.routeId === routeId)?.weatherRoutingInfo?.id;
        return html`
                <div class="action-wrapper row13">
                    <mc-button appearance="primary" fit="small" width="full-width" @click=${() => this._showAdvice(wrRouteId)} icon="clipboard-list-text">
                        Show Advice
                    </mc-button>
                </div>
            <div class="action-wrapper row14">
                <mc-button appearance="neutral" fit="small" width="full-width" @click=${()=>{this._onDismissAdviceClicked(routeId)}}>Dismiss Advice</mc-button>
                <mc-button appearance="neutral" fit="small" width="full-width" @click=${()=>{this._onAcceptAdviceClicked(routeId, index)}}>Accept Advice</mc-button>
            </div>

            <p class="wr-info-text">
                *by accepting, the WNI advice will be merged with the <br /> current plan.
            </p>

            <p class="wr-info-text">
                *by dismissing the advice, you have to provide <br /> justification and you will continue with the current plan.
            </p>
        `;
    }

    private _renderAlignStarRouteModal() {
       return html`<align-star-route-modal 
       @alignStarRoute-modal-clicked=${(e:CustomEvent)=>this._handleModalClick(e)} 
       .showModalStarAlign=${this._showAlignStarRouteModal} 
       .modalContent=${this._renderEachCard()}></align-star-route-modal>`

    }

    _handleModalClick(event: CustomEvent) {
        if(event.detail.id === ""){
            this._showAlignStarRouteModal = false;
            this.requestUpdate();
            return
        }
        this._showAlignStarRouteModal = false;
        const routeID = this._plan!.routes[this._selectedUiRouteIndex].routeId;
        if(event.detail.id && routeID) {
            this._editRoute(routeID);
            if(event.detail.id && routeID) this.setStarRouteLayerVisibility(event.detail.id, routeID)
            this.requestUpdate();
        }
    }
    private _renderPlanningActions() {
        let indexVal: number = 0;
        indexVal = this._findIndex(this._routes, (item:any) => item.route == null);
        if(!this._plan) return;
        const isBprAvailable = VoyageBestPracticeRoutesModel!.getBPRsByScheduleId(this.scheduleId);
        const isBprJobPending = VoyageBestPracticeRoutesModel!.hasPendingBPRJob(this.scheduleId);

        const isStarRouteFetchDisabled = starRouteFetchDisabled(this._plan.etd);
        return html`
            <div class="action-wrapper row1">
            <mc-button appearance="neutral" fit="small" width="full-width" icon="arrows-left-right" ?disabled = "${this._getRouteVals().length ? false: true}" @click=${() => {
                this._showCompareTable=true
                UiStateModel!.setValue(UiStateModelParam.MainMenuComponent,'--');
            }}>Compare all routes</mc-button>
            </div>
            ${(this.showBprLoader || !this._isBestPracticeRouteAvailable || isStarRouteFetchDisabled ) ? html`` :
            !isBprAvailable || isBprAvailable?.length === 0 ? (isBprJobPending ? html`
             <div class="action-wrapper row2">
                <mc-button appearance="secondary" fit="small" width="full-width" disabled>Loading...</mc-button>
             </div>
            ` : html`
             <div class="action-wrapper row2">
                <mc-button appearance="secondary" fit="small" width="full-width" disabled>Request another star route</mc-button>
             </div>
            `) :
            html`
            <div class="action-wrapper row2">
                <mc-button appearance="secondary" fit="small" width="full-width" ?disabled =${isStarRouteFetchDisabled} @click=${() => this._onRquestAnotherStarRoute(indexVal)}>Request another star route</mc-button>
            </div>
            ${this._isOOREnabled ? html`
            <div class="action-wrapper row2">
                <mc-button appearance="secondary" fit="small" width="full-width" ?disabled=${isStarRouteFetchDisabled} @click=${() => this._onRequestAnotherOpenOceanRoute(indexVal)}>Request another open ocean route</mc-button>
            </div>` : nothing}`
            }
            <div class="action-wrapper row3">
                <mc-button appearance="neutral" fit="small" width="full-width" style = ${"flex:1"} @click=${() => this._onNewUserRouteClicked(indexVal)}>Create Own route</mc-button>
                <label for="upload1" class="upload">Upload route</label>
                    <input id="upload1" type="file"
                    accept=".json,application/json,.csv,.rte,.rtz,.xml,application/xml,.route" @change=${ (evt: Event) => this._importRoute(evt, indexVal, true) } single>
 

            </div>
            <div class="action-wrapper row4 footer-text">You can have maximum 5 routes including Star Routes. </div>
             <voyage-route-comparison .shown=${this._showCompareTable} ._plan=${this._plan} @close=${() => this._showCompareTable = false} .routes = ${this._routes} .calculatedVals=${this._getRouteVals()}> </voyage-route-comparison>
             <voy-error-popup .shown=${this._showMaxRouteDialog} @close=${() => this._showMaxRouteDialog = false} header = "Maximum number of routes reached" content = "You can have only 5 routes at the time. Please delete some of the unnecessary routes to create or generate new ones."> </voy-error-popup>
        `;
    }

    private _bestPracticeRouteChanged(e: Event) {
        const detail = (<CustomEvent>e).detail;
        
        switch (detail.isRouteAvailable) {
            case BestPracticeRoutesEvents.FetchingRoute:
                this._isBestPracticeRouteAvailable = false;
                break;
            case BestPracticeRoutesEvents.RouteNotAvaliable:
                this._isBestPracticeRouteAvailable = false;
                this._updateBestPracticeRoute(false, false, "", "", null);
                break;
            case BestPracticeRoutesEvents.RouteDoneFetching:
                
                const route = this._plan!.routes.find(r => r.uiType === "UserRoute0");
                if (this._plan!.routes.length > 0 && route) {
                    route.name = "AutoRoute";
                    this._updateBestPracticeRoute(true, false, "", "", route);
                }
                break;
        }
    
        this.requestUpdate();
    }
    
    private _updateBestPracticeRoute(available: boolean, selected: boolean, comment: string, reason: string, route: VoyageRoute | null): void {
        if (this._plan!.passagePlan.bestPracticeRoute) {
            this._plan!.passagePlan.bestPracticeRoute = {
                comment: comment,
                reason: reason,
                selected: selected,
                available: available,
                route: route,
            };
            VesselPlanningModel!.setPlan(this._scheduleId, this._plan!, false);
        }
    }
    

    private async _importRoute(evt: Event, index: number, warnForSpos: boolean, type?: string)
    {
        if(index === -1) {
            this._showMaxRouteDialog = true;
            return;
        }
        const files = (<HTMLInputElement>evt.target).files;
        if (!files || files.length === 0)
        {
            return;
        }
        const file = files[0];
        const fileExtension = file.name.split('.').pop()?.toLowerCase() ?? null;
        const previousSelectedRouteId = this._plan?.currentSelectedRouteId;
        const previousSelectedRoute = this._plan?.routes.find(route => route.routeId === previousSelectedRouteId);
        const wasStarRoutePresent = this._plan?.routes.some(route => route.routeCreatedBy === 'system') ?? false;
        // Resolved before the import, which may replace the Star Route in its slot
        const roundTripStarRoute = findExportedStarRouteForImport(this._plan?.routes, file.name);

        // Clear file input to allow uploading same file again
        (<HTMLInputElement>evt.target).value = "";
        if (warnForSpos)
        {
            const text = await file.text();
            if (SposConverter.check(text))
            {
                const dialog = VoyageDialogPopupManager.createDialog({
                    headerText: "Importing SPOS file",
                    bodyText: "Uploading SPOS file - this might result in a strange route view.\nSPOS files are intended to be imported on top of an already loaded route.\nDo you want to continue?",
                    acceptButtonText: "Continue",
                    rejectButtonText: "Cancel"
                });

                if ((await dialog.getResponse()) === "reject")
                {
                    return;
                }
            }
        }

        const executingPlan = await VesselPlanningModel!.getExecutingPlan();

        if (executingPlan && executingPlan.scheduleId === this.scheduleId && this._currentPositionOutdated() && isOnline())
        {
            VoyageDialogPopupManager.createDialog({
                headerText: "Vessel position outdated",
                bodyText: "Vessel position is too old. Please input the vessels current position first."
            });
            return;
        }
        try
        {
            const isExecutingPlanUnderway = executingPlan && executingPlan.scheduleId === this.scheduleId && this._plan!.etd < new Date().getTime()
            const id = UUID();
            const existingWeatherRoutingInfo = this._plan!.routes?.[index]?.weatherRoutingInfo;
            const weatherRoutingInfo: WeatherRoutingInfo | undefined = existingWeatherRoutingInfo
                ? {
                    ...existingWeatherRoutingInfo,
                    required: existingWeatherRoutingInfo.required ?? false,
                    required_reason: WniRequiredReason.Manual,
                }
                : undefined;
            const options: RoutingJobOptions = {
                routeId: id, 
                draftFore: this._plan!.foreDraft,
                draftAft: this._plan!.aftDraft,
                gmt: this._plan!.gmt !== null ? this._plan!.gmt : undefined,
                etd: isExecutingPlanUnderway ? Date.now() : this._plan!.etd,
                eta: this._plan!.eta,
                rollAngle: this._plan!.rollAngle !== null ? this._plan!.rollAngle : undefined,
                numberOfReefers: this._plan!.numberOfReefers,
                routeType: "WeatherOptimized",
                uiRouteIndex: index,
                planScheduleId: this._scheduleId,
                updatePlan: {
                    routeIndex: this._getRoutePlanIndex(id)
                },
                weatherRoutingInfo,
                solidGm: this._plan!.solidGm !== null ? this._plan!.solidGm : undefined,
            };
            
            const mergeWith = await this._getImportMergeRoute(index);
            let missingPoints: MissingPoints | null = null;
            let selectedRoute;
            if (type === 'spos') {
                //TODO- change this logic to fetch based on id
                selectedRoute = this._plan?.routes.find(route => route.routeId === id);
                const arrWithPP: number[] = [];
                
                selectedRoute?.route_geometry.forEach((feature, idx )=> {
                    if (feature.properties.pilotPoint) {
                        arrWithPP.push(idx)
                    }
                })
                // import from SPOS is possible from pilot to pilot. 
                // we need to add points from berth to pilot and from the last pilot to berth to imported route.
                if (arrWithPP.length >= 2) {
                    missingPoints = {
                        beforeFistPilotPoint: selectedRoute?.route_geometry.slice(0, arrWithPP[0]+1),
                        afterLastPilotPoint: selectedRoute?.route_geometry.slice(arrWithPP[arrWithPP.length - 1]),
                    }
                }
            }

            const importedRoute = await VoyageRoutingModel!.importFile(file, options, missingPoints,  mergeWith ? mergeWith : selectedRoute, (isOnline()) ? (mergeWith !== null) : false);

            const adoption = await this._annotateStarRouteDeviation(importedRoute);
            const roundTripComparison = roundTripStarRoute ? await this._compareWithExportedStarRoute(file, roundTripStarRoute) : null;
            const uploadSource: RouteUploadSource = roundTripStarRoute ? 'star-route-round-trip' : 'own-route';

            captureStarRouteWrWorkflowEvent("route-imported", {
                scheduleId: this._scheduleId,
                planId: this._plan?.id ?? null,
                importedRouteId: importedRoute?.routeId ?? id,
                slotIndex: index,
                fileName: file.name,
                fileExtension,
                wasStarRoutePresent,
                previousSelectedRouteId,
                previousSelectedRouteCreatedBy: previousSelectedRoute?.routeCreatedBy,
                previousSelectedWasStarRoute: previousSelectedRoute?.routeCreatedBy === 'system',
                mergeWithRouteId: mergeWith?.routeId ?? selectedRoute?.routeId ?? null,
                weatherRoutingRequired: weatherRoutingInfo?.required ?? null,
                weatherRoutingRequiredReason: weatherRoutingInfo?.required_reason ?? null,
                // Provenance: decided by the file having been exported from a Star Route, never by similarity
                uploadSource,
                isRoundTripOfStarRoute: !!roundTripStarRoute,
                roundTripStarRouteId: roundTripStarRoute?.routeId,
                roundTripStarRouteOrigin: roundTripStarRoute ? getRouteOrigin(roundTripStarRoute) : null,
                roundTripBestPracticeRouteId: roundTripStarRoute?.bestPracticeRouteId,
                // '' when not a round trip or the uploaded file could not be compared
                wasModifiedBeforeReimport: roundTripComparison?.wasModified,
                waypointCountDelta: roundTripComparison?.waypointCountDelta,
                // Informational only, never used for uploadSource; '' when the check did not run (toggle off, offline, failed)
                starRouteAligned: adoption?.adopted,
                alignedBprId: adoption?.bprId,
            });

            this._checkRoute(index);
        }
        catch (err)
        {
            // capture uplaod error and show user friendly message based on file type and content
            console.log("Error importing route", err);
            const extension = file ? file.name.split('.').pop()?.toLowerCase() : null;
            const isSupportedFormat = files && validateExtension(extension || "");
            captureStarRouteWrWorkflowEvent("route-import-failed", {
                scheduleId: this._scheduleId,
                planId: this._plan?.id ?? null,
                slotIndex: index,
                fileName: file.name,
                fileExtension,
                isSupportedFormat: !!isSupportedFormat,
                wasStarRoutePresent,
                uploadSource: roundTripStarRoute ? 'star-route-round-trip' : 'own-route',
                isRoundTripOfStarRoute: !!roundTripStarRoute,
                roundTripStarRouteId: roundTripStarRoute?.routeId,
                errorMessage: err instanceof Error ? err.message : `${err}`,
            });
            if(!isSupportedFormat) {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Unsupported file format",
                    bodyText: `The selected file format is not supported.\nPlease upload a valid route file.\nSupported route formats: SPOS, Nacos, RTZ 1.0, RTZ 1.2, Sperry, JRC, StarConnect Voyage Planning file format,\n SPOS PilotToPilot, StarConnect Basic Excel CSV format.`,
                    isError: true
                });
                return;
            } else {
                    const rtzValidationBodyText = await this._getValidationBodyText(file, extension);
                    VoyageDialogPopupManager.createDialog({
                    headerText: "Error Uploading Route",
                    bodyText: rtzValidationBodyText || "There was an error trying to upload your route.\nPlease try again.",
                    isError: true
                });
            }
        }
    }

    // Re-parses the uploaded file on its own (no merge with the slot's route, no routing job) so the waypoints compared
    // are exactly the ones the vessel uploaded.
    private async _compareWithExportedStarRoute(file: File, starRoute: VoyageRoute): Promise<{ wasModified: boolean; waypointCountDelta: number } | null> {
        try {
            const { route } = await importFromFile(file);
            return compareReimportedRouteWithStarRoute(route.route_geometry, starRoute.route_geometry);
        } catch (error) {
            console.warn('Could not compare re-uploaded Star Route file with its Star Route:', error);
            return null;
        }
    }

    // Annotates an uploaded route with per-waypoint deviation from the top-1 star route (resolved
    // server-side) so exceeded waypoints render as amber. Degrades silently offline.
    private async _annotateStarRouteDeviation(importedRoute: VoyageRoute | null | undefined): Promise<RouteAdoptionResult | null> {
        if (!isStarRouteDeviationEnabled() || !importedRoute?.route_geometry?.length || !this._plan) {
            return null;
        }
        try {
            const planRoute = this._plan.routes.find(r => r.routeId === importedRoute.routeId) ?? importedRoute;
            const topStarRoute = getMostFuelEfficientStarRoute(this._plan.routes);
            const adoption = await VesselPlanningModel!.getRouteAdoption(planRoute, topStarRoute?.bestPracticeRouteId, {
                departureTerminalCode: this._plan.departureTerminalCode,
                arrivalTerminalCode: this._plan.arrivalTerminalCode,
                scheduleId: this._scheduleId,
            });
            planRoute.bprAlignment = {
                isAligned: adoption.adopted,
                bprId: adoption.bprId || topStarRoute?.bestPracticeRouteId || '',
            };
            if (adoption.route?.route_geometry) {
                planRoute.route_geometry = adoption.route.route_geometry;
            }
            await VesselPlanningModel!.setPlan(this._scheduleId, this._plan, false);
            return adoption;
        } catch (error) {
            console.error('Error annotating star route deviation on upload:', error);
            return null;
        }
    }

    private async _getValidationBodyText(file: File, extension: string | null | undefined): Promise<string | null> {
        if (extension !== "rtz" && extension !== "xml") {
            return null;
        }

        try {
            const text = await file.text();
            const looksLikeRtz = /<route\b/i.test(text) && /xmlns=["'][^"']*\/RTZ\/\d\/\d["']/i.test(text);
            if (!looksLikeRtz && extension !== "rtz") {
                return null;
            }

            const validation = RTZConverter.validate(text, { filename: file.name });
            if (validation.valid || validation.errors.length === 0) {
                return null;
            }

            return `There was an error trying to upload your route.\nValidation errors:\n- ${validation.errors.join("\n- ")}`;
        } catch {
            return null;
        }
    }

    private async _deleteRoute(routeId: string)
    {
        try
        {
            // delete route from plan
            const planIndex = this._plan!.routes.findIndex(element => element.routeId === routeId);
            
            if (planIndex !== -1)
            {
                const wasSelectedRoute = this._plan!.selectedRouteIndex == planIndex || this._plan!.currentSelectedRouteId === routeId;
                if (this._plan!.selectedRouteIndex == planIndex)
                {
                    this._plan!.selectedRouteIndex = -1;
                }
                else if (this._plan!.currentSelectedRouteId === routeId) {
                    this._plan!.currentSelectedRouteId = "";
                }
                // deleted star/OOR route should keep in a separate array
                if(this._plan!.routes[planIndex].routeCreatedBy === "system") {
                    if (this._plan!.routes[planIndex].uiType === 'OOR') {
                        VoyageBestPracticeRoutesModel!.updateDeletedOOR(this._plan?.scheduleId || "", this._plan?.routes[planIndex].bestPracticeRouteId || "", false);
                    } else {
                        VoyageBestPracticeRoutesModel!.updateDeletedStarRoute( this._plan?.scheduleId || "", this._plan?.routes[planIndex]. bestPracticeRouteId||"",false);
                    }
                }
                this._plan!.routes.splice(planIndex, 1);
                this._selectedUiRouteIndex = this._plan!.selectedRouteIndex;

                if (wasSelectedRoute) {
                    // The deleted route was the selected one, so no route is selected anymore -
                    // any shallow-soundings warning raised for it is now stale.
                    const imo = isVesselOnCloud ? VoyageImoModel!.imo! : (<any>window)["appenv"].vesselIMONumber;
                    this._updateShallowSoundingsAlert(imo, null);
                }

                await VesselPlanningModel!.setPlan(this._scheduleId, this._plan!, false);
                // updating this to show the toast
                this.showDeleteToast = true;
            }
        }
        catch (err)
        {
            VoyageDialogPopupManager.createDialog({
                headerText: "A Technical Error Has Occured",
                bodyText: "Failed to save plan",
                errorDetails: (<Error>err).message,
                isError: true
            });
        }
    
    }

    private _getCalculatedValues(routeId: string, index: number): CalculatedValues {
        const routeObject = this._routes.find(route => route.route?.routeId === routeId);
        if (!routeObject || !routeObject.route || !routeObject.route.route_info) {
            return getDefaultCalculatedValues();
        }
        const route = routeObject.route;
        const showIndex = getSegregatedRouteIndices(routeId ,this._routes);
    
        const calculatedValues = calculateRouteValues(route, showIndex);
        this._routes[index].calculatedValues = calculatedValues;
        return calculatedValues
    }
    
    private _onRoutesChanged() {
        const oldSelectedIndex = this._selectedIndex;
        this._selectedIndex = -1;

        // Update internal array and check for changes
        for (let i = 0; i < 5; i++) {
            const routeObj = VoyageRoutingModel!.uiRoutes[i];
            const calculatedValues = getDefaultCalculatedValues();
            const a = {...routeObj, calculatedValues};
            this._routes[i] = Object.assign({}, a);
            if (routeObj?.selected) {
                this._selectedIndex = i;
            }
        }

        // Only overwrite selectedUiRoute if the plan (from backend) is set
        if (this._selectedIndex !== -1) {
            this._selectedUiRouteIndex = this._selectedIndex;
        }

        if (this._selectedIndex !== oldSelectedIndex) {
            this._dispatchSelectionChanged();
        }

        this.requestUpdate();
    }

    private _onWeatherLimitsChanged()
    {
        this._checkForRecalc();
        if(this._plan) {
            // triggering the BPR calculation 
            VoyageBestPracticeRoutesModel!.getRankedBPRsForSchedule(this._plan, true);
        }
    }

    private _onPlanChanged(evt: PlanChangedEvent) {
        if (evt.detail.scheduleId === this.scheduleId) {
            this._updateFromPlan(false);
        }
        this._onRoutesChanged();
    }


    private async _updateFromPlan(initialLoad: boolean)
    {
        this._plan = await VesselPlanningModel!.getCurrentPlan(this.scheduleId);
        this._updateStarRouteUkcWarning();
        if (initialLoad)
        {
            await VoyageRoutingModel!.setActivePlan(this._scheduleId);

            // Check for weirdness in pilot points and trigger warnings if needed
            const uiRoutes = VoyageRoutingModel!.uiRoutes;
            for (let i = 0; i < uiRoutes.length; i++)
            {
                this._checkRoute(i);
            }
            this._checkForRecalc();
        }
    }

    private async _checkForRecalc()
    {
        if (!this._plan)
        {
            return;
        }

        const uiRoutes = VoyageRoutingModel!.uiRoutes;
        const fromPos = this._plan.startPosition;
        const toPos = this._plan.endPosition;
        

        // Check for outdated calculations and trigger a new calculations when needed
        const routeChanges: {index: number, changes: RouteChange}[] = [];
        for (let i = 0; i < uiRoutes.length; i++)
        {
            const routeId = this._plan.routes?.[i]?.routeId ?? "";
            const weatherRoutingInfo = this._plan.routes?.[i]?.weatherRoutingInfo;
            const passagePlan  = this._plan.routes?.[i]?.passagePlan;
            const calcOptions: RoutingJobOptions = {
                routeId: routeId,
                draftFore: this._plan.foreDraft,
                draftAft: this._plan.aftDraft,
                gmt: this._plan.gmt !== null ? this._plan.gmt : undefined,
                etd: this._plan.etd,
                eta: this._plan.eta,
                rollAngle: this._plan.rollAngle !== null ? this._plan.rollAngle : undefined,
                numberOfReefers: this._plan.numberOfReefers,
                routeType: "WeatherOptimized",
                passagePlan: passagePlan,
                weatherRoutingInfo: weatherRoutingInfo,
                solidGm: this._plan.solidGm !== null ? this._plan.solidGm : undefined,
            }

            if (uiRoutes[i].status === "idle" || uiRoutes[i].status === "failed")
            {
                // Ignore changes to the start and end coordinates for now, since end and start points are likely to differ
                const changes = await this._routeChanges(uiRoutes[i].route!, fromPos!, toPos!, calcOptions, true);
                if (changes)
                {
                    if (changes === RouteChange.NotCalculated)
                    {
                        // Start calculation immediately, no need to ask first
                        this._triggerCalculation(i);
                        return;
                    }
                    else
                    {
                        routeChanges.push({
                            index: i,
                            changes
                        });
                    }
                }
            }
        }

        if (isVesselOnCloud ? (routeChanges.length > 0 && isOnline()) : routeChanges.length > 0)
        {
            const reason = routeChanges[0].changes;
            const text = RouteChangeToTextMap.get(reason) || "";

            const dialog = VoyageDialogPopupManager.createDialog({
                headerText: "Re-calculation needed",
                bodyText: `${text} Route re-calculation is necessary.\n\nPress “Re-Calculate” to re-calculate the route.`,
                acceptButtonText: "Re-Calculate",
                rejectButtonText: "Cancel"
            });

            const response = await dialog.getResponse();
            if (response === "accept")
            {
                for (const routeChange of routeChanges)
                {
                    this._triggerCalculation(routeChange.index);
                }
            }
        }
    }

    private async _routeChanges(route: VoyageRoute, from: [number,number], to: [number,number], calcOptions: RoutingJobOptions,
                                ignoreCoordinates: boolean): Promise<RouteChange>
    {
        if (!route) {
            return RouteChange.None;
        }

        if (!route.route_info) {
            // Not calculated yet
            return RouteChange.NotCalculated;
        }

        // Check for change in start/end position
        let routeStart = null;
        let routeEnd = null;
        for (const feature of route.route_geometry) {
            if (feature.geometry.type === "Point") {
                routeEnd = feature.geometry.coordinates;
                if (!routeStart) {
                    routeStart = feature.geometry.coordinates;
                }
            }
        }

        if (!ignoreCoordinates && (from[0] !== routeStart![0] || from[1] !== routeStart![1] || to[0] !== routeEnd![0] || to[1] !== routeEnd![1])) {
            return RouteChange.Coordinates;
        }

        // Check for new drafts, new gmt, new start/end time and new forecast available
        const weatherForecastVersion = isVesselOnCloud ? WeatherModel!.hydraLatestForecastVersion : WeatherModel!.latestForecastVersion;
        if (weatherForecastVersion !== route.route_info.calculationInput.forecast_versions[0]) {
            return RouteChange.NewForecast;
        }

        if (route.route_info.weather.hasHighResData === false && WeatherModel!.latestForecastInfo!.hasHighResData) {
            return RouteChange.ForecastUpdated;
        }

        if (calcOptions.draftFore !== route.route_info.calculationInput.draftFore ||
            calcOptions.draftAft !== route.route_info.calculationInput.draftAft) {
            return RouteChange.Draft;
        }

        if (calcOptions.gmt !== route.route_info.calculationInput.gmt) {
            return RouteChange.GMt;
        }

        // Skip ETD check for executing routes (since the ETD will change when replanning)
        const executingPlan = await VesselPlanningModel!.getExecutingPlan();
        if (!(executingPlan && executingPlan.scheduleId === this.scheduleId))
        {
            if (new Date(calcOptions.etd!).getTime() - new Date(route.route_info.calculationInput.etd).getTime() !== 0) {
                return RouteChange.ETD;
            }    
        }

        if (new Date(calcOptions.eta!).getTime() - new Date(route.route_info.calculationInput.eta).getTime() !== 0) {
            return RouteChange.ETA;
        }

        // Check for changes in weather limits
        const currentWeatherLimits = VoyageRoutingModel!.getWeatherLimits();
        if (!deepEqual(currentWeatherLimits, route.route_info.calculationInput.weatherLimits)) {
            return RouteChange.WeatherLimits;
        }

        return RouteChange.None;
    }

    private async _triggerCalculation(uiRouteIndex: number) {
        const calcOptions: RoutingJobOptions = {
            routeId: VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.routeId,
            uiRouteIndex,
            planScheduleId: this._scheduleId,
            updatePlan: {
                routeIndex: this._getRoutePlanIndex(VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.routeId)
            },
            draftFore: this._plan!.foreDraft,
            draftAft: this._plan!.aftDraft,
            gmt: this._plan!.gmt !== null ? this._plan!.gmt : undefined,
            etd: this._plan!.etd,
            eta: this._plan!.eta,
            rollAngle: this._plan!.rollAngle !== null ? this._plan!.rollAngle : undefined,
            numberOfReefers: this._plan!.numberOfReefers,
            routeType: "WeatherOptimized",
            whaleZonesApplied: VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.route_info?.whaleZonesApplied,
            disableWhaleZoneSpeedRestrictions: VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.route_info?.disableWhaleZoneSpeedRestrictions,
            passagePlan: VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.passagePlan,
            weatherRoutingInfo : VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!?.weatherRoutingInfo,
            solidGm: this._plan!.solidGm !== null ? this._plan!.solidGm : undefined,
        }

        VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!.recalcNeeded = true;

        const executingPlan = await VesselPlanningModel!.getExecutingPlan();
        if (executingPlan && executingPlan.scheduleId === this.scheduleId)
        {
            if (this._currentPositionOutdated() && isOnline())
            {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Vessel position outdated",
                    bodyText: "Vessel position is too old. Please input the vessels current position first."
                });
                return;
            }

            // Mark passed waypoints, add current position and calculate from now
            try
            {
                // only add position as waypoint and mark passed if the plan's etd is in the past
                if(executingPlan.etd < new Date().getTime()) {
                    await markPassedAndAddCurrentPosition(VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!);
                }
            }
            catch (err: any)
            {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Re-calculation error",
                    bodyText: `Failed to add current position to Route ${uiRouteIndex+1}`,
                    isError: true,
                    errorDetails: err.message
                });
                return;
            }
            
            this._plan!.etd < new Date().getTime() ? calcOptions.etd = Date.now() : calcOptions.etd = this._plan!.etd;
            
        }

        if(this._plan!.etd < new Date().getTime()) {
            await markPassedAndAddCurrentPosition(VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!);
        }
        await VoyageRoutingModel!.postRoutingJobUsingRoute(VoyageRoutingModel!.uiRoutes[uiRouteIndex].route!, calcOptions);
        this.requestUpdate();
    }

    private _getRoutePlanIndex(routeId: string) {
        return this._plan!.routes.findIndex( route => route.routeId === routeId);
    }

    private _onFeatureFlagsUpdated = () => {
        this.requestUpdate();
    };

    // The whale zone route action differs by mode, so the flag decides which button is rendered:
    // with const_pow_endpoint_v2 the analytics constant-power calculation applies the restrictions
    // and the action opts out of them, without it the browser stamps the zones onto the waypoints.
    // Read from the feature flags response per render, since it is refreshed periodically.
    private get _constPowEndpointV2Enabled(): boolean {
        return FeatureFlagModel?.hasFeatureFlag(CONST_POW_ENDPOINT_V2) === true;
    }

    // Pre-v2 route action: fetches the whale zones and stamps their speed limits onto the route's
    // waypoints in the browser. Only reachable while const_pow_endpoint_v2 is disabled; with v2 the
    // restrictions are applied by the analytics constant-power calculation instead.
    private async _applyZones(routeIndex: number, utilities: ZonesUtilities) {
        const route = VoyageRoutingModel!.uiRoutes[routeIndex].route!;
        const planIndex = this._plan!.routes.findIndex( element => element.routeId === route.routeId);
        try {
            this._plan!.routes[planIndex] = await utilities.applyToRoute(route);
        } catch (error) {
            VoyageDialogPopupManager.createDialog({
                headerText: "Whale Zones Unavailable",
                bodyText: "Could not fetch whale zone data. Whale zones could not be applied.\nPlease try again later, if it continues to fail, please contact support.",
                noCloseButton: true
            });
            throw error;
        }

        this._triggerCalculation(routeIndex);
    }

    // Analytics applies the whale zone speed restrictions by default during the optimisation
    // (calculate-constant-power / best-practice-routes). Setting
    // route_info.disableWhaleZoneSpeedRestrictions makes the routeoptimiser send the whale zone as
    // zones_to_ignore for this route, so the restrictions are left out of the recalculation
    // triggered here and out of later recalculations of the same route.
    private _disableWhaleZoneSpeedRestrictions(routeIndex: number) {
        const route = VoyageRoutingModel!.uiRoutes[routeIndex].route!;
        if (route.route_info) {
            route.route_info.disableWhaleZoneSpeedRestrictions = true;
        }

        const planIndex = this._plan!.routes.findIndex( element => element.routeId === route.routeId);
        if (planIndex >= 0) {
            this._plan!.routes[planIndex] = route;
        }

        this._triggerCalculation(routeIndex);
    }

    private _setNavtexValues = () => {
        // check if navtex values are available in currentSelectedRouteIndex's passageplan
        const currentSelectedRouteIndex = this._plan?.routes.findIndex((route) => route.routeId === this._plan?.currentSelectedRouteId) ?? this._plan!.selectedRouteIndex;
        const weatherInfoNavtexStations = this._plan!.routes[currentSelectedRouteIndex].passagePlan?.weatherInfo.navtexStations;
        const weatherInfoNavareaRegions = this._plan!.routes[currentSelectedRouteIndex].passagePlan?.weatherInfo.navareaRegions;
        const safetyMessagesNavareaRegions = this._plan!.routes[currentSelectedRouteIndex].passagePlan?.safetyMessages.navareaRegions;
        const safetyMessagesNavtexStations = this._plan!.routes[currentSelectedRouteIndex].passagePlan?.safetyMessages.navtexStations;
        const sailingDirections = this._plan!.routes[currentSelectedRouteIndex].passagePlan?.sailingDirections;
        if (!sailingDirections || sailingDirections === "") {
            this._plan!.routes[currentSelectedRouteIndex].passagePlan!.sailingDirections = DataExtractor.getDataFromPlan("sailingDirections", this._plan) as string;
        }
        if (!weatherInfoNavtexStations || weatherInfoNavtexStations === "") {
            this._plan!.routes[currentSelectedRouteIndex].passagePlan!.weatherInfo.navtexStations = DataExtractor.getDataFromPlan("weatherInfoNavtexStations", this._plan) as string;
        }
        if (!weatherInfoNavareaRegions || weatherInfoNavareaRegions === "") {
            this._plan!.routes[currentSelectedRouteIndex].passagePlan!.weatherInfo.navareaRegions = DataExtractor.getDataFromPlan("weatherInfoNavareaRegions", this._plan) as string;
        }
        if (!safetyMessagesNavareaRegions || safetyMessagesNavareaRegions === "") {
            this._plan!.routes[currentSelectedRouteIndex].passagePlan!.safetyMessages.navareaRegions = DataExtractor.getDataFromPlan("safetyMessagesNavareaRegions", this._plan) as string;
        }
        if (!safetyMessagesNavtexStations || safetyMessagesNavtexStations === "") {
            this._plan!.routes[currentSelectedRouteIndex].passagePlan!.safetyMessages.navtexStations = DataExtractor.getDataFromPlan("safetyMessagesNavtexStations", this._plan) as string;
        }
        this.requestUpdate();
    }

    private async _alignWithStarRoute(index: number, routeId: string,isSelect: boolean = false) {

            const dialog =  VoyageDialogPopupManager.createDialog({
                headerText: "Optimize Your Voyage with StarRoute",
                bodyText: "Would you like to align your route with StarRoute?\n\nStarRoute offers energy-efficient and safe route recommendations to help ensure a smoother and more fuel-efficient voyage.\n\nBy choosing this option, you can align your route with StarRoute while maintaining the flexibility to use your own route.",
                acceptButtonText: "Yes, I would",
                rejectButtonText: "No",
                alignLeft: true
            });
            const response = await dialog.getResponse();
            if (response === "accept") {
              this._showAlignStarRouteModal = true;
              this.requestUpdate();
            }
            else if(response === "reject") {
                const routeObject = this._routes.find(route => route.route?.routeId === routeId);
                if(isSelect && routeObject) {
                    this._selectRoute(index, routeId,routeObject!);
                }
                else {
                    this._editRoute(routeId);
                }
                this.requestUpdate();
            }
            return;
    }

    private async _alignWithStarRouteOne(name: string, index: number, routeId: string, routeObject: UIRouteWithCalculatedValues) {
        const dialog =  VoyageDialogPopupManager.createDialog({
            headerText: "Would you like to switch to Star Route No.1?",
            bodyText: `Since you have selected ${name}, Please be informed that Star Route 1 is an even more fuel-efficient route than what you have selected.`,
            acceptButtonText: "Yes, I would",
            rejectButtonText: "No",
            alignLeft: true
        });
        const response = await dialog.getResponse();
        
        if (response === "accept") {
            //get the Star route1 and select that route
            const starRouteOneIndex = this._routes!.findIndex(route => route?.route?.name === "Star Route 1");
            const routeObjectstarRoute = this._routes[starRouteOneIndex];
            const routeIdstarRoute = routeObjectstarRoute.route?.routeId || "";

            this._selectRoute(starRouteOneIndex, routeIdstarRoute, routeObjectstarRoute!);
            this.requestUpdate();
        }
        if (response === "reject") {
            //continue with the selected route
            this._selectRoute(index, routeId,routeObject);
            this.requestUpdate();
          }
        return;
    }

    private async _selectRouteId(index: number, routeId: string) {
        // The route's precautionary zone warnings have to be reviewed first.
        if (this._needsWarningsReview(routeId)) return;

        const routeObject = this._routes.find(route => route.route?.routeId === routeId);
        if (!routeObject || !this._plan) return;
        this._selectedUiRouteIndex = this._plan!.routes.findIndex(route => route.routeId === routeId);

        // show allign with star route popup if user selects a non-star route
        const isStarRoute = this._plan!.routes[ this._selectedUiRouteIndex].routeCreatedBy === "system"
        const name = routeObject?.route?.name || "";
        const isBprAvailable  = this._plan?.routes.filter(route => route.routeCreatedBy === 'system') ||[];
        const isOwnRouteMoreEfficientThanStarRoute = checkIfOwnRouteIsMoreFuelEfficientThanStarRouteOne(this._plan, routeId);
        const isWrRoute = this._plan!.routes[ this._selectedUiRouteIndex].routeCreatedBy === "WR"

        if(!isOwnRouteMoreEfficientThanStarRoute && !isStarRoute && isBprAvailable?.length && !routeObject.route?.bprAlignment?.isAligned  && this._plan?.etd > Date.now() && !isWrRoute) {

            this._alignWithStarRoute(index, routeId, true);
        } 
        else if (isStarRoute && name !== "Star Route 1" && this._plan?.etd > Date.now()) {
            this._alignWithStarRouteOne(name, index, routeId, routeObject);
        } else {
            this._selectRoute(index, routeId, routeObject);
        }  
    }

    private _updateShallowSoundingsAlert(imo: number, route: VoyageRoute | null | undefined) {
        if (localStorage.getItem(ISHIGHLIGHTSHALLOWSOUNDINGSENABLED) !== 'true') {
            return;
        }
        const shallowSoundings = route && this._plan
            ? extractShallowSoundings(route, this._plan.foreDraft, this._plan.aftDraft)
            : [];
        if (shallowSoundings.length) {
            VesselAlertsModel!.addAlert(imo, {
                type: AlertType.ShallowSoundingsWarning,
                message: 'The selected route passes through areas of shallow water. Review before submitting.',
                id: 'shallow-soundings-warning',
                shallowSoundings,
            });
        } else {
            VesselAlertsModel!.removeAlertsByType(imo, AlertType.ShallowSoundingsWarning);
        }
    }

    // Warns when the plan offers no alternative to a risky Star Route: every suggested
    // route is a Star Route (no OOR, WR, or user-drawn route to fall back on) and at
    // least one of them has negative under keel clearance.
    private _updateStarRouteUkcWarning() {
        // Skip while a Star Route recalculation is in flight - this._plan.routes still reflects
        // the previous (soon to be stale) results until _checkIfBPRisAvailable confirms it's done.
        if (this._hideBprRoute) {
            return;
        }
        const imo = isVesselOnCloud ? VoyageImoModel!.imo! : (<any>window)["appenv"].vesselIMONumber;
        const isStarRoute = (route: VoyageRoute) => route.routeCreatedBy === 'system' && route.uiType !== 'OOR';

        const onlyStarRoutesWithNegativeUkc = !!this._plan?.routes.length
            && this._plan.routes.every(isStarRoute)
            && this._plan.routes.some(route =>
                extractShallowSoundings(route, this._plan!.foreDraft, this._plan!.aftDraft).some(sounding => (sounding.ukc ?? 0) < 0)
            );

        if (onlyStarRoutesWithNegativeUkc) {
            VesselAlertsModel!.addAlert(imo, {
                type: AlertType.StarRouteNegativeUkcWarning,
                message: 'Note: showing StarRoutes with negative UKC',
                id: 'star-route-negative-ukc-warning',
            });
        } else {
            VesselAlertsModel!.removeAlertsByType(imo, AlertType.StarRouteNegativeUkcWarning);
        }
    }

    private async _selectRoute(index: number, routeId: string, routeObject: UIRouteWithCalculatedValues) {
        const imo = isVesselOnCloud ? VoyageImoModel!.imo! : (<any>window)["appenv"].vesselIMONumber;

        this._currentSelectedRouteId = routeId;
        const isPlanApproved = this._plan!.status === "approved";

        this._updateShallowSoundingsAlert(imo, routeObject.route);

            if (routeObject.status === "failed") {
                const failedRoute: FailedUIRouteWithMetadata = {...routeObject, index};
                this._nonHydraCalculatedRouteSelected = failedRoute;
                this._plan!.currentSelectedRouteId = routeId;
                this.requestUpdate();
            } else {
                this._nonHydraCalculatedRouteSelected = null;
                this._plan!.currentSelectedRouteId = routeId;
            }
            if(!isPlanApproved) {
    
            // have selected route in the first index of the plan routes
            // this is to have the selected index at top of the list always
            if (this._plan!.currentSelectedRouteId) {
                const selectedRouteIndex = this._plan!.routes.findIndex(route => route.routeId === this._plan!.currentSelectedRouteId);
                const selectedRoute = this._plan!.routes[selectedRouteIndex];
                if (selectedRouteIndex > 0) {
                    this._plan!.routes.splice(selectedRouteIndex, 1);
                    this._plan!.routes.unshift(selectedRoute);
                    this._selectedUiRouteIndex = 0;
                }
            }
        } else if (routeObject.route?.routeCreatedBy === "WR") {
        const selectedRouteIndex = this._plan!.routes.findIndex(route => route.routeId === this._plan!.currentSelectedRouteId);
            const selectedRoute = this._plan!.routes[selectedRouteIndex];
            if (selectedRouteIndex > 0) {
                if(this._plan!.status === "approved") {
                    faro.api.pushEvent("approved-plan-status-change", {
                        imo: `${imo}`,
                        trigger: "_selectRoute - WR selectedRouteIndex changed",
                    });
                }
                this._plan!.routes.splice(selectedRouteIndex, 1);
                this._plan!.routes.unshift(selectedRoute);
                this._selectedUiRouteIndex = 0;
                this._plan!.status = "planning";         
            }
    }
    this._setNavtexValues();
     VesselPlanningModel!.setPlan(this._scheduleId, this._plan!, false);
    }

    private _dispatchSelectionChanged() {
        // if the index is empty (i.e. when deleting), the querySelector will fail
        if (this._selectedIndex === -1) return;

        const element = this.shadowRoot!.querySelector(`.routeIcon[route="${this._selectedIndex+1}"]`);
        if (!element) {
            return;
        }

        const style = getComputedStyle(element);
        const color = style.stroke;

        this.dispatchEvent(new CustomEvent('selection-changed', {detail: { index: this._selectedIndex, color: color }}));
    }

    private async _onNewUserRouteClicked(index: number)
    {
        if(index === -1){
            this._showMaxRouteDialog = true;
            return;
        }
        VoyageBestPracticeRoutesModel!.ifRouteShouldBeFetched(false, this._plan?.scheduleId)
        const plan = (await VesselPlanningModel!.getCurrentPlan(this.scheduleId))!;
        const route: VoyageRoute = {
            routeId: UUID(),
            recalcNeeded: true,
            route_geometry: [],
            routeCreatedBy: "bridge",
        }
        let replanning = false;

        const executingPlan = await VesselPlanningModel!.getExecutingPlan();
        if (executingPlan && executingPlan.scheduleId === this.scheduleId)
        {
            // Editing executing plan -> start with already passed waypoints, current position and destination waypoint
            // + relevant pilot point(s)
            if (this._currentPositionOutdated() && isOnline())
            {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Vessel position outdated",
                    bodyText: "Vessel position is too old. Please input the vessels current position first."
                });
                return;
            }

            replanning = true;
            const executingRoute: RouteGeometry = JSON.parse(JSON.stringify(executingPlan.routes[executingPlan.selectedRouteIndex].route_geometry));
            const allPilotPoints = <VoyageRoutePointFeature[]>executingRoute.filter((feature) => feature.geometry.type === "Point" && feature.properties.pilotPoint);
            const pilotPoints = [...allPilotPoints]; //shallow copy so it can be modified independently

            const nextWPIndex = await getNextWaypointIndex(executingRoute, true);
            let nextToLastPointFound = false;
            for (let i = nextWPIndex-1; i >= 0; i--)
            {
                if (!nextToLastPointFound)
                {
                    if (executingRoute[i].geometry.type === "Point" &&
                        (executingRoute[i].properties.type === "Hard" || executingRoute[i].properties.type === "Navigational"))
                    {
                        nextToLastPointFound = true;
                    }
                    else
                    {
                        // skip
                        continue;
                    }
                }

                if (executingRoute[i].geometry.type === "Point")
                {
                    const ppIndex = pilotPoints.indexOf(<VoyageRoutePointFeature>executingRoute[i]);
                    if (ppIndex !== -1)
                    {
                        pilotPoints.splice(ppIndex, 1);
                    }

                    // Make sure isPassed is set
                    if (!isPointWithinStoppageWindow(executingRoute, i))
                    {
                        executingRoute[i].properties.isPassed = true;
                    }
                }
                route.route_geometry.unshift(executingRoute[i]);
            }
            //only add current position WP, if executing plan and if the plan has 2 pilot points
            if(allPilotPoints.length >=2) {
                insertCurrentPositionWP(route.route_geometry);
            }
            else {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Missing Pilot Points",
                    bodyText: `Route contains fewer than two Pilot Points.\nIf this is not intentional, return to Route Editor to add more Pilot Points`,
                });
                return;
            }
            // Add any relevant pilot points
            for (const pilotPoint of pilotPoints)
            {
                this._addPointToRouteGeometry(route.route_geometry, pilotPoint.geometry.coordinates, pilotPoint.properties.eta, true);
            }
            
            this._addPointToRouteGeometry(route.route_geometry, plan.endPosition!);
        }
        else
        {
            // Start with start and destination waypoints + pilot points if specified
            this._addPointToRouteGeometry(route.route_geometry, plan.startPosition!);
            if (plan.departurePilotPosition !== null) {
                this._addPointToRouteGeometry(route.route_geometry, plan.departurePilotPosition, plan.departurePilotEtd, true);
            }

            if (plan.arrivalPilotPosition !== null) {
                this._addPointToRouteGeometry(route.route_geometry, plan.arrivalPilotPosition, plan.arrivalPilotEta, true);
            }

            if (plan.startPosition![0] === plan.endPosition![0] && plan.startPosition![1] === plan.endPosition![1])
            {
                // Plan has the same start and end position - slightly adjust end position north by ~50 meters to allow route editing to work
                this._addPointToRouteGeometry(route.route_geometry, [plan.endPosition![0], plan.endPosition![1] + 0.0005]);
                
            }
            else
            {
                this._addPointToRouteGeometry(route.route_geometry, plan.endPosition!);
            }
        }

        RouteEditModel!.editRoute(route.routeId, index, this._scheduleId, route, replanning, replanning ? Date.now() : undefined);
        this.dispatchEvent(new CustomEvent('route-editor-click', {detail: { routeId: route.routeId }}));
    }

    private _addPointToRouteGeometry(routeGeometry: (VoyageRoutePointFeature|VoyageRouteLineFeature)[], point: [number,number],
                                     eta?: number|string, isPilot?: boolean) {
        // Add a line from the last point to the current one.
        if (routeGeometry.length > 0) {
            const lastPoint = <[number,number]>routeGeometry[routeGeometry.length - 1].geometry.coordinates;
            routeGeometry.push({
                type: "Feature",
                geometry: {coordinates: [lastPoint, point], type: "LineString"},
                properties: {leg_type: "Rhumbline"}
            });
        }

        let pointFeature: VoyageRoutePointFeature = {
            type: "Feature",
            geometry: {coordinates: point, type: "Point"},
            properties: {type: "Hard"}
        }
        if (eta && eta as number > 0) {
            pointFeature.properties.eta = new Date(eta).toISOString();
        }
        if (isPilot) {
            pointFeature.properties.pilotPoint = true;
        }
        routeGeometry.push(pointFeature);
    }

    private async _onRouteEditorClicked(index: number, event: Event, routeId: string): Promise<void> {
        event.stopPropagation();
        const routeIndex = this._plan?.routes?.findIndex(route => route?.routeId === routeId)
        this._selectedUiRouteIndex = this._plan!.routes.findIndex(route => route.routeId === routeId);

        const isStarRoute = this._plan!.routes[this._selectedUiRouteIndex]?.routeCreatedBy === "system"
        const isBprAvailable  = this._plan?.routes.filter(route => route.routeCreatedBy === 'system')|| [];    
        const isOwnRouteMoreEfficientThanStarRoute = checkIfOwnRouteIsMoreFuelEfficientThanStarRouteOne(this._plan!, routeId);
        const isAligned: boolean | undefined = routeIndex !== undefined ? this._plan?.routes[routeIndex]?.bprAlignment?.isAligned : false

        if(!isOwnRouteMoreEfficientThanStarRoute && !isStarRoute && isBprAvailable?.length && !isAligned && this._plan!.etd > Date.now()) {
            this._alignWithStarRoute(index, routeId);
        }
        else {
            this._editRoute(routeId);
        }
    }

    private async _editRoute(routeId: string) {
        const routeObject = this._routes.find(route => route.route?.routeId === routeId);
        const route = routeObject?.route;

        if(!route) return;
        let replanning = false;
        const executingPlan = await VesselPlanningModel!.getExecutingPlan();
        if (executingPlan && executingPlan.scheduleId === this.scheduleId)
        {
            replanning = true;

            // Mark passed waypoints and insert current position
            if (this._currentPositionOutdated() && isOnline())
            {
                VoyageDialogPopupManager.createDialog({
                    headerText: "Vessel position outdated",
                    bodyText: "Vessel position is too old. Please input the vessels current position first."
                });
                return;
            }
            // only add position as waypoint and mark passed if the plan's etd is in the past
            if(executingPlan.etd < new Date().getTime()) {
                await markPassedAndAddCurrentPosition(route, true, true);
            }
        }
        VoyageBestPracticeRoutesModel!.ifRouteShouldBeFetched(false, this._plan?.scheduleId);
        const uiRouteIndex = this._routes.findIndex(route => route.route?.routeId === routeId);
        if (uiRouteIndex === -1) return;
        routeObject && await this._selectRoute(uiRouteIndex, routeId, routeObject);
        RouteEditModel!.editRoute(routeId,uiRouteIndex, this._scheduleId, route, replanning, replanning ? Date.now() : undefined);
        this.dispatchEvent(new CustomEvent('route-editor-click', {detail: { routeId }}));
    }

    private async _getImportMergeRoute(index: number): Promise<VoyageRoute|null>
    {
        let route = null;

        // Route uploads are placed in the first empty card. A route in an empty card is
        // a fresh alternative and must start with the uploaded route's first waypoint,
        // rather than inheriting passed waypoints from the approved/executing route.
        if (!this._routes[index]?.route)
        {
            return route;
        }

        const executingPlan = await VesselPlanningModel!.getExecutingPlan();
        if (executingPlan && executingPlan.scheduleId === this.scheduleId)
        {
            // When replacing an existing executing route, preserve its passed section.
            route = <VoyageRoute>JSON.parse(JSON.stringify(executingPlan.routes[executingPlan.selectedRouteIndex]));

            await markPassedWaypoints(route);
        }

        return route;
    }

    private _currentPositionOutdated(): boolean
    {
        if (VesselPositionModel!.usingManualPositionOverride || VesselPositionModel!.malfunctioningGPS)
        {
            // If we are using manual position, check that the position is current
            const acceptedTime = 1000*60*15; // Accept position if it is newer than 15 minutes
            const position = VesselPositionModel!.position;
            if (!position || position.latitude === null || position.longitude === null || new Date(position.timestamp).getTime() + acceptedTime < Date.now())
            {
                return true;
            }
        }
        return false;
    }

    private _checkRoute(index: number): void
    {
        // Check for weirdness in pilot points and trigger warning if needed
        const uiRoutes = VoyageRoutingModel!.uiRoutes;
        if (uiRoutes[index]?.route)
        {
            const routeGeometry = uiRoutes[index].route!.route_geometry;
            if (routeGeometry[0].properties.pilotPoint)
            {
                let pilotPointCount = 0;
                for (const feature of routeGeometry)
                {
                    if (feature.properties.pilotPoint)
                    {
                        pilotPointCount++;
                    }
                }
                if (pilotPointCount === 1)
                {
                    // First point is a pilot point and the only pilot point present
                    const dialog = VoyageDialogPopupManager.createDialog({
                        headerText: "Warning: Abnormal pilot points detected",
                        bodyText: `The pilot points for route ${index+1} will not produce a valid passage plan (only one pilot point defined and it is the first waypoint)`,
                    });
                }
            }
        }
    }
    
    private _findIndex(array:any, condition:any): number {
        return array.findIndex(condition);
    }

    private _getRouteVals() {
        let calculatedValues: any = [];
        this._routes?.map((route, index) => {
            const routeId = route.route?.routeId ?? '';
            let temp:any = this._getCalculatedValues(routeId, index);
            if(temp?.distance && temp?.distance !== "-" ) {
             calculatedValues[calculatedValues.length] = temp;
            }
        })
    return calculatedValues;
    }

    private async _onRquestAnotherStarRoute(index: number) {
        //show dialog if max routes reached
        if(index === -1){
            this._showMaxRouteDialog = true;
            return;
        }
        const bprExistsInLatestPlan = this._plan!.routes.filter((route) =>  route.routeCreatedBy === 'system');
        const noOfStarRoutesInPlan = bprExistsInLatestPlan.length;
        const deletedStarRoutes = VoyageBestPracticeRoutesModel!.getDeletedByScheduleId(this._plan?.scheduleId || "");
        const optimizedBPRs = await VesselPlansService.getOptimizedBPRsByPortPair( this._plan!.departureTerminalCode,  this._plan!.arrivalTerminalCode, this._plan!.scheduleId);
        
        if(optimizedBPRs!.length === 0) {
            VoyageDialogPopupManager.createDialog({
                headerText: "No Star Routes available",
                bodyText:" Sorry!!No Star Routes available for this port pair."
            });
            return;
        
         }
         else if(noOfStarRoutesInPlan >= optimizedBPRs!.length) {
            VoyageDialogPopupManager.createDialog({
                headerText: "Star Route limit reached",
                bodyText: "No further Star Routes available for this voyage."
            });
            return;
         }
         else if(noOfStarRoutesInPlan >= (optimizedBPRs!.length-deletedStarRoutes.length)) {
           const dialog =  VoyageDialogPopupManager.createDialog({
                headerText: "Star Route limit reached",
                bodyText: "No further Star Routes available for this voyage",
                acceptButtonText: "Restore deleted Star Routes",
                rejectButtonText: "Cancel"
            });
            const response = await dialog.getResponse();
            if (response === "accept") {
                VoyageBestPracticeRoutesModel!.updateDeletedStarRoute(this._plan?.scheduleId || "","",true);
                VoyageBestPracticeRoutesModel!.requestAnotherStarRoute( this._plan?.scheduleId || "",optimizedBPRs, noOfStarRoutesInPlan);
            }
            return;
         }

        VoyageBestPracticeRoutesModel!.requestAnotherStarRoute( this._plan?.scheduleId || "",optimizedBPRs, noOfStarRoutesInPlan);

    }

    private async _onRequestAnotherOpenOceanRoute(index: number) {
        if (index === -1) {
            this._showMaxRouteDialog = true;
            return;
        }

        const oorsInPlan = this._plan!.routes.filter(r => r.uiType === 'OOR');
        const noOfOORsInPlan = oorsInPlan.length;
        const deletedOORs = VoyageBestPracticeRoutesModel!.getDeletedOORByScheduleId(this._plan?.scheduleId || "");
        const optimizedOORs = await VesselPlansService.getOptimizedOORsByPortPair(
            this._plan!.departureTerminalCode,
            this._plan!.arrivalTerminalCode,
            this._plan!.scheduleId
        );

        if (!optimizedOORs || optimizedOORs.length === 0) {
            VoyageDialogPopupManager.createDialog({
                headerText: "No Open Ocean Routes available",
                bodyText: "No Open Ocean Routes available for this port pair."
            });
            return;
        }

        if (noOfOORsInPlan >= optimizedOORs.length) {
            VoyageDialogPopupManager.createDialog({
                headerText: "Open Ocean Route limit reached",
                bodyText: "No further Open Ocean Routes available for this voyage."
            });
            return;
        }

        if (noOfOORsInPlan >= (optimizedOORs.length - deletedOORs.length)) {
            const dialog = VoyageDialogPopupManager.createDialog({
                headerText: "Open Ocean Route limit reached",
                bodyText: "No further Open Ocean Routes available for this voyage.",
                acceptButtonText: "Restore deleted Open Ocean Routes",
                rejectButtonText: "Cancel"
            });
            const response = await dialog.getResponse();
            if (response === "accept") {
                VoyageBestPracticeRoutesModel!.updateDeletedOOR(this._plan?.scheduleId || "", "", true);
                VoyageBestPracticeRoutesModel!.requestAnotherOpenOceanRoute(this._plan?.scheduleId || "", optimizedOORs, noOfOORsInPlan);
            }
            return;
        }

        VoyageBestPracticeRoutesModel!.requestAnotherOpenOceanRoute(this._plan?.scheduleId || "", optimizedOORs, noOfOORsInPlan);
    }
}
